import React, { useState, useRef, useCallback, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

// ============================================================
// SUPABASE CONFIG
// ============================================================
const SUPABASE_URL  = "https://pcqevsspnqdslvuxmucl.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjcWV2c3NwbnFkc2x2dXhtdWNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY3ODY1ODEsImV4cCI6MjA5MjM2MjU4MX0.1LgxtxqDxbtdfQzRcJbUF34zzD2bpKowwSJ0LRD2q3I";
// ============================================================
// Client aangemaakt bij module load — geen async CDN nodig
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
const sb = () => supabase;


const VERSION = "v0.36";

// --- RAL DATABASE -------------------------------------------------------------
const RAL = [
  {code:"RAL 1000",name:"Groenbeige",nameEn:"Green beige",hex:"#CDBA88",rgb:[205,186,136],cmyk:[0,9,34,20]},
  {code:"RAL 1001",name:"Beige",nameEn:"Beige",hex:"#D0B084",rgb:[208,176,132],cmyk:[0,15,37,18]},
  {code:"RAL 1002",name:"Zandgeel",nameEn:"Sand yellow",hex:"#D2AA6D",rgb:[210,170,109],cmyk:[0,19,48,18]},
  {code:"RAL 1003",name:"Signaalgeel",nameEn:"Signal yellow",hex:"#F9A900",rgb:[249,169,0],cmyk:[0,32,100,2]},
  {code:"RAL 1004",name:"Goudgeel",nameEn:"Golden yellow",hex:"#E49E00",rgb:[228,158,0],cmyk:[0,31,100,11]},
  {code:"RAL 1005",name:"Honinggeel",nameEn:"Honey yellow",hex:"#CB8F00",rgb:[203,143,0],cmyk:[0,30,100,20]},
  {code:"RAL 1006",name:"Maisgeel",nameEn:"Maize yellow",hex:"#E19000",rgb:[225,144,0],cmyk:[0,36,100,12]},
  {code:"RAL 1007",name:"Narcissengeel",nameEn:"Daffodil yellow",hex:"#E88C00",rgb:[232,140,0],cmyk:[0,40,100,9]},
  {code:"RAL 1011",name:"Bruinbeige",nameEn:"Brown beige",hex:"#AF8050",rgb:[175,128,80],cmyk:[0,27,54,31]},
  {code:"RAL 1012",name:"Citroengeel",nameEn:"Lemon yellow",hex:"#DDAF28",rgb:[221,175,40],cmyk:[0,21,82,13]},
  {code:"RAL 1013",name:"Parelwit",nameEn:"Oyster white",hex:"#E3D9C7",rgb:[227,217,199],cmyk:[0,4,12,11]},
  {code:"RAL 1014",name:"Ivoorkleurig",nameEn:"Ivory",hex:"#DDC49B",rgb:[221,196,155],cmyk:[0,11,30,13]},
  {code:"RAL 1015",name:"Licht ivoorkleurig",nameEn:"Light ivory",hex:"#E6D2B5",rgb:[230,210,181],cmyk:[0,9,21,10]},
  {code:"RAL 1016",name:"Zwavelgeel",nameEn:"Sulfur yellow",hex:"#F1DD39",rgb:[241,221,57],cmyk:[0,8,76,5]},
  {code:"RAL 1017",name:"Saffraangeel",nameEn:"Saffron yellow",hex:"#F6A951",rgb:[246,169,81],cmyk:[0,31,67,4]},
  {code:"RAL 1018",name:"Zinkgeel",nameEn:"Zinc yellow",hex:"#FACA31",rgb:[250,202,49],cmyk:[0,19,80,2]},
  {code:"RAL 1019",name:"Grijsbeige",nameEn:"Grey beige",hex:"#A48F7A",rgb:[164,143,122],cmyk:[0,13,26,36]},
  {code:"RAL 1020",name:"Olijfgeel",nameEn:"Olive yellow",hex:"#A08F65",rgb:[160,143,101],cmyk:[0,11,37,37]},
  {code:"RAL 1021",name:"Koolzaadgeel",nameEn:"Colza yellow",hex:"#F6B600",rgb:[246,182,0],cmyk:[0,26,100,4]},
  {code:"RAL 1023",name:"Verkeersgeel",nameEn:"Traffic yellow",hex:"#F7B500",rgb:[247,181,0],cmyk:[0,27,100,3]},
  {code:"RAL 1024",name:"Okergeel",nameEn:"Ochre yellow",hex:"#BA8F4C",rgb:[186,143,76],cmyk:[0,23,59,27]},
  {code:"RAL 1026",name:"Briljantgeel",nameEn:"Luminous yellow",hex:"#FFFF00",rgb:[255,255,0],cmyk:[0,0,100,0]},
  {code:"RAL 1027",name:"Kerriegeel",nameEn:"Curry",hex:"#A77F0F",rgb:[167,127,15],cmyk:[0,24,91,35]},
  {code:"RAL 1028",name:"Meloengeel",nameEn:"Melon yellow",hex:"#FF9C00",rgb:[255,156,0],cmyk:[0,39,100,0]},
  {code:"RAL 1032",name:"Bremgeel",nameEn:"Broom yellow",hex:"#E2A300",rgb:[226,163,0],cmyk:[0,28,100,11]},
  {code:"RAL 1033",name:"Dahliageel",nameEn:"Dahlia yellow",hex:"#F99A1D",rgb:[249,154,29],cmyk:[0,38,88,2]},
  {code:"RAL 1034",name:"Pastelgeel",nameEn:"Pastel yellow",hex:"#EB9C52",rgb:[235,156,82],cmyk:[0,34,65,8]},
  {code:"RAL 1035",name:"Parelmoergrijs",nameEn:"Pearl beige",hex:"#8F8370",rgb:[143,131,112],cmyk:[0,8,22,44]},
  {code:"RAL 1036",name:"Parelmoergoud",nameEn:"Pearl gold",hex:"#806440",rgb:[128,100,64],cmyk:[0,22,50,50]},
  {code:"RAL 1037",name:"Zonnegeel",nameEn:"Sun yellow",hex:"#F09200",rgb:[240,146,0],cmyk:[0,39,100,6]},
  {code:"RAL 2000",name:"Geeloranje",nameEn:"Yellow orange",hex:"#DA6E00",rgb:[218,110,0],cmyk:[0,50,100,15]},
  {code:"RAL 2001",name:"Roodoranje",nameEn:"Red orange",hex:"#BA481C",rgb:[186,72,28],cmyk:[0,61,85,27]},
  {code:"RAL 2002",name:"Vermiljoen",nameEn:"Vermilion",hex:"#BF3922",rgb:[191,57,34],cmyk:[0,70,82,25]},
  {code:"RAL 2003",name:"Pasteloranje",nameEn:"Pastel orange",hex:"#F67829",rgb:[246,120,41],cmyk:[0,51,83,4]},
  {code:"RAL 2004",name:"Zuiver oranje",nameEn:"Pure orange",hex:"#E25304",rgb:[226,83,4],cmyk:[0,63,98,11]},
  {code:"RAL 2005",name:"Briljantoranje",nameEn:"Luminous orange",hex:"#FF4D08",rgb:[255,77,8],cmyk:[0,70,97,0]},
  {code:"RAL 2007",name:"Briljant lichtoranje",nameEn:"Luminous bright orange",hex:"#FFB200",rgb:[255,178,0],cmyk:[0,30,100,0]},
  {code:"RAL 2008",name:"Licht roodoranje",nameEn:"Bright red orange",hex:"#EC6B22",rgb:[236,107,34],cmyk:[0,55,86,7]},
  {code:"RAL 2009",name:"Verkeersoranje",nameEn:"Traffic orange",hex:"#DE5308",rgb:[222,83,8],cmyk:[0,63,96,13]},
  {code:"RAL 2010",name:"Signaaloranje",nameEn:"Signal orange",hex:"#D05D29",rgb:[208,93,41],cmyk:[0,55,80,18]},
  {code:"RAL 2011",name:"Dieporanje",nameEn:"Deep orange",hex:"#E26E0F",rgb:[226,110,15],cmyk:[0,51,93,11]},
  {code:"RAL 2012",name:"Zalmoranje",nameEn:"Salmon orange",hex:"#D5654E",rgb:[213,101,78],cmyk:[0,53,63,16]},
  {code:"RAL 2013",name:"Parelmoeroranje",nameEn:"Pearl orange",hex:"#923E25",rgb:[146,62,37],cmyk:[0,58,75,43]},
  {code:"RAL 2017",name:"RAL oranje",nameEn:"RAL orange",hex:"#FC5500",rgb:[252,85,0],cmyk:[0,66,100,1]},
  {code:"RAL 3000",name:"Vuurrood",nameEn:"Flame red",hex:"#A72920",rgb:[167,41,32],cmyk:[0,75,81,35]},
  {code:"RAL 3001",name:"Signaalrood",nameEn:"Signal red",hex:"#9B2423",rgb:[155,36,35],cmyk:[0,77,77,39]},
  {code:"RAL 3002",name:"Karmijnrood",nameEn:"Carmine red",hex:"#9B2321",rgb:[155,35,33],cmyk:[0,77,79,39]},
  {code:"RAL 3003",name:"Robijnrood",nameEn:"Ruby red",hex:"#861A22",rgb:[134,26,34],cmyk:[0,81,75,47]},
  {code:"RAL 3004",name:"Purperrood",nameEn:"Purple red",hex:"#6B1C23",rgb:[107,28,35],cmyk:[0,74,67,58]},
  {code:"RAL 3005",name:"Wijnrood",nameEn:"Wine red",hex:"#59191F",rgb:[89,25,31],cmyk:[0,72,65,65]},
  {code:"RAL 3007",name:"Zwartrood",nameEn:"Black red",hex:"#3E2022",rgb:[62,32,34],cmyk:[0,48,45,76]},
  {code:"RAL 3009",name:"Oxyderood",nameEn:"Oxide red",hex:"#6D342D",rgb:[109,52,45],cmyk:[0,52,59,57]},
  {code:"RAL 3011",name:"Bruinrood",nameEn:"Brown red",hex:"#782423",rgb:[120,36,35],cmyk:[0,70,71,53]},
  {code:"RAL 3012",name:"Beigerood",nameEn:"Beige red",hex:"#C5856D",rgb:[197,133,109],cmyk:[0,32,45,23]},
  {code:"RAL 3013",name:"Tomaatrood",nameEn:"Tomato red",hex:"#972E25",rgb:[151,46,37],cmyk:[0,70,75,41]},
  {code:"RAL 3014",name:"Oudroze",nameEn:"Antique pink",hex:"#CB7375",rgb:[203,115,117],cmyk:[0,43,42,20]},
  {code:"RAL 3015",name:"Lichtroze",nameEn:"Light pink",hex:"#D8A0A6",rgb:[216,160,166],cmyk:[0,26,23,15]},
  {code:"RAL 3016",name:"Koraalrood",nameEn:"Coral red",hex:"#A63D30",rgb:[166,61,48],cmyk:[0,63,71,35]},
  {code:"RAL 3017",name:"Bleekrood",nameEn:"Rose",hex:"#CA555D",rgb:[202,85,93],cmyk:[0,58,54,21]},
  {code:"RAL 3018",name:"Aardbeirood",nameEn:"Strawberry red",hex:"#C63F4A",rgb:[198,63,74],cmyk:[0,68,63,22]},
  {code:"RAL 3020",name:"Verkeersrood",nameEn:"Traffic red",hex:"#BB1F11",rgb:[187,31,17],cmyk:[0,83,91,27]},
  {code:"RAL 3022",name:"Zalmrood",nameEn:"Salmon pink",hex:"#CF6955",rgb:[207,105,85],cmyk:[0,49,59,19]},
  {code:"RAL 3024",name:"Briljantrood",nameEn:"Luminous red",hex:"#FF2D21",rgb:[255,45,33],cmyk:[0,82,87,0]},
  {code:"RAL 3026",name:"Briljant lichtrood",nameEn:"Luminous bright red",hex:"#FF2A1C",rgb:[255,42,28],cmyk:[0,84,89,0]},
  {code:"RAL 3027",name:"Framboosrood",nameEn:"Raspberry red",hex:"#AB273C",rgb:[171,39,60],cmyk:[0,77,65,33]},
  {code:"RAL 3028",name:"Zuiver rood",nameEn:"Pure red",hex:"#CC2C24",rgb:[204,44,36],cmyk:[0,78,82,20]},
  {code:"RAL 3031",name:"Oriëntrood",nameEn:"Orient red",hex:"#A63437",rgb:[166,52,55],cmyk:[0,69,67,35]},
  {code:"RAL 3032",name:"Parelmoerdonkerrood",nameEn:"Pearl ruby red",hex:"#701D24",rgb:[112,29,36],cmyk:[0,74,68,56]},
  {code:"RAL 3033",name:"Parelmoerlichtrood",nameEn:"Pearl pink",hex:"#A53A2E",rgb:[165,58,46],cmyk:[0,65,72,35]},
  {code:"RAL 4001",name:"Roodlila",nameEn:"Red lilac",hex:"#816183",rgb:[129,97,131],cmyk:[2,26,0,49]},
  {code:"RAL 4002",name:"Roodpaars",nameEn:"Red violet",hex:"#8D3C4B",rgb:[141,60,75],cmyk:[0,57,47,45]},
  {code:"RAL 4003",name:"Heidepaars",nameEn:"Heather violet",hex:"#C4618C",rgb:[196,97,140],cmyk:[0,51,29,23]},
  {code:"RAL 4004",name:"Bordeauxpaars",nameEn:"Claret violet",hex:"#651E38",rgb:[101,30,56],cmyk:[0,70,45,60]},
  {code:"RAL 4005",name:"Blauwlila",nameEn:"Blue lilac",hex:"#76689A",rgb:[118,104,154],cmyk:[23,32,0,40]},
  {code:"RAL 4006",name:"Verkeerspurper",nameEn:"Traffic purple",hex:"#903373",rgb:[144,51,115],cmyk:[0,65,20,44]},
  {code:"RAL 4007",name:"Purperviolet",nameEn:"Purple violet",hex:"#47243C",rgb:[71,36,60],cmyk:[0,49,15,72]},
  {code:"RAL 4008",name:"Signaalviolet",nameEn:"Signal violet",hex:"#844C82",rgb:[132,76,130],cmyk:[0,42,2,48]},
  {code:"RAL 4009",name:"Pastelviolet",nameEn:"Pastel violet",hex:"#9D8692",rgb:[157,134,146],cmyk:[0,15,7,38]},
  {code:"RAL 4010",name:"Telemagenta",nameEn:"Telemagenta",hex:"#BB4077",rgb:[187,64,119],cmyk:[0,66,36,27]},
  {code:"RAL 4011",name:"Parelmoerdonkerviolet",nameEn:"Pearl violet",hex:"#6E6387",rgb:[110,99,135],cmyk:[19,27,0,47]},
  {code:"RAL 4012",name:"Parelmoerlichtviolet",nameEn:"Pearl blackberry",hex:"#6A6B7F",rgb:[106,107,127],cmyk:[17,16,0,50]},
  {code:"RAL 5000",name:"Paarsblauw",nameEn:"Violet blue",hex:"#304F6E",rgb:[48,79,110],cmyk:[56,28,0,57]},
  {code:"RAL 5001",name:"Groenblauw",nameEn:"Green blue",hex:"#0E4C64",rgb:[14,76,100],cmyk:[86,24,0,61]},
  {code:"RAL 5002",name:"Ultramarijnblauw",nameEn:"Ultramarine blue",hex:"#00387A",rgb:[0,56,122],cmyk:[100,54,0,52]},
  {code:"RAL 5003",name:"Saffierblauw",nameEn:"Sapphire blue",hex:"#1F3855",rgb:[31,56,85],cmyk:[64,34,0,67]},
  {code:"RAL 5004",name:"Zwartblauw",nameEn:"Black blue",hex:"#191E28",rgb:[25,30,40],cmyk:[38,25,0,84]},
  {code:"RAL 5005",name:"Signaalblauw",nameEn:"Signal blue",hex:"#005387",rgb:[0,83,135],cmyk:[100,39,0,47]},
  {code:"RAL 5007",name:"Briljantblauw",nameEn:"Brillant blue",hex:"#376B8C",rgb:[55,107,140],cmyk:[61,24,0,45]},
  {code:"RAL 5008",name:"Grijsblauw",nameEn:"Grey blue",hex:"#2B3A44",rgb:[43,58,68],cmyk:[37,15,0,73]},
  {code:"RAL 5009",name:"Azuurblauw",nameEn:"Azure blue",hex:"#215F78",rgb:[33,95,120],cmyk:[73,21,0,53]},
  {code:"RAL 5010",name:"Gentiaanblauw",nameEn:"Gentian blue",hex:"#004F7C",rgb:[0,79,124],cmyk:[100,36,0,51]},
  {code:"RAL 5011",name:"Staalblauw",nameEn:"Steel blue",hex:"#1A2B3C",rgb:[26,43,60],cmyk:[57,28,0,76]},
  {code:"RAL 5012",name:"Lichtblauw",nameEn:"Light blue",hex:"#0089B6",rgb:[0,137,182],cmyk:[100,25,0,29]},
  {code:"RAL 5013",name:"Kobaltblauw",nameEn:"Cobalt blue",hex:"#193153",rgb:[25,49,83],cmyk:[70,41,0,67]},
  {code:"RAL 5014",name:"Duifblauw",nameEn:"Pigeon blue",hex:"#637D96",rgb:[99,125,150],cmyk:[34,17,0,41]},
  {code:"RAL 5015",name:"Hemelsblauw",nameEn:"Sky blue",hex:"#007CAF",rgb:[0,124,175],cmyk:[100,29,0,31]},
  {code:"RAL 5017",name:"Verkeersblauw",nameEn:"Traffic blue",hex:"#005B8C",rgb:[0,91,140],cmyk:[100,35,0,45]},
  {code:"RAL 5018",name:"Turkooisblauw",nameEn:"Turquoise blue",hex:"#048B8C",rgb:[4,139,140],cmyk:[97,1,0,45]},
  {code:"RAL 5019",name:"Capriblauw",nameEn:"Capri blue",hex:"#005E83",rgb:[0,94,131],cmyk:[100,28,0,49]},
  {code:"RAL 5020",name:"Oceaanblauw",nameEn:"Ocean blue",hex:"#00414B",rgb:[0,65,75],cmyk:[100,13,0,71]},
  {code:"RAL 5021",name:"Waterblauw",nameEn:"Water blue",hex:"#007577",rgb:[0,117,119],cmyk:[100,2,0,53]},
  {code:"RAL 5022",name:"Nachtblauw",nameEn:"Night blue",hex:"#222D5A",rgb:[34,45,90],cmyk:[62,50,0,65]},
  {code:"RAL 5023",name:"Verblauw",nameEn:"Distant blue",hex:"#41698C",rgb:[65,105,140],cmyk:[54,25,0,45]},
  {code:"RAL 5024",name:"Pastelblauw",nameEn:"Pastel blue",hex:"#6093AC",rgb:[96,147,172],cmyk:[44,15,0,33]},
  {code:"RAL 5025",name:"Parelmoerblauw",nameEn:"Pearl gentian blue",hex:"#20697C",rgb:[32,105,124],cmyk:[74,15,0,51]},
  {code:"RAL 5026",name:"Parelmoernachtblauw",nameEn:"Pearl night blue",hex:"#0F3052",rgb:[15,48,82],cmyk:[82,41,0,68]},
  {code:"RAL 6000",name:"Patinagroen",nameEn:"Patina green",hex:"#3C7460",rgb:[60,116,96],cmyk:[48,0,17,55]},
  {code:"RAL 6001",name:"Smaragdgroen",nameEn:"Emerald green",hex:"#366735",rgb:[54,103,53],cmyk:[48,0,49,60]},
  {code:"RAL 6002",name:"Loofgroen",nameEn:"Leaf green",hex:"#325928",rgb:[50,89,40],cmyk:[44,0,55,65]},
  {code:"RAL 6003",name:"Olijfgroen",nameEn:"Olive green",hex:"#50533C",rgb:[80,83,60],cmyk:[4,0,28,67]},
  {code:"RAL 6004",name:"Blauwgroen",nameEn:"Blue green",hex:"#024442",rgb:[2,68,66],cmyk:[97,0,3,73]},
  {code:"RAL 6005",name:"Mosgroen",nameEn:"Moss green",hex:"#114232",rgb:[17,66,50],cmyk:[74,0,24,74]},
  {code:"RAL 6006",name:"Grijs olijfgroen",nameEn:"Grey olive",hex:"#3C392E",rgb:[60,57,46],cmyk:[0,5,23,76]},
  {code:"RAL 6007",name:"Flessengroen",nameEn:"Bottle green",hex:"#2C3222",rgb:[44,50,34],cmyk:[12,0,32,80]},
  {code:"RAL 6008",name:"Bruingroen",nameEn:"Brown green",hex:"#36342A",rgb:[54,52,42],cmyk:[0,4,22,79]},
  {code:"RAL 6009",name:"Dennengroen",nameEn:"Fir green",hex:"#27352A",rgb:[39,53,42],cmyk:[26,0,21,79]},
  {code:"RAL 6010",name:"Grasgroen",nameEn:"Grass green",hex:"#4D6F39",rgb:[77,111,57],cmyk:[31,0,49,56]},
  {code:"RAL 6011",name:"Resedagroen",nameEn:"Reseda green",hex:"#6B7C59",rgb:[107,124,89],cmyk:[14,0,28,51]},
  {code:"RAL 6012",name:"Zwartgroen",nameEn:"Black green",hex:"#2F3D3A",rgb:[47,61,58],cmyk:[23,0,5,76]},
  {code:"RAL 6013",name:"Rietgroen",nameEn:"Reed green",hex:"#7C765A",rgb:[124,118,90],cmyk:[0,5,27,51]},
  {code:"RAL 6014",name:"Geel olijfgroen",nameEn:"Yellow olive",hex:"#474135",rgb:[71,65,53],cmyk:[0,8,25,72]},
  {code:"RAL 6015",name:"Zwart olijfgroen",nameEn:"Black olive",hex:"#3D3D36",rgb:[61,61,54],cmyk:[0,0,11,76]},
  {code:"RAL 6016",name:"Turkooisgroen",nameEn:"Turquoise green",hex:"#00694C",rgb:[0,105,76],cmyk:[100,0,28,59]},
  {code:"RAL 6017",name:"Meigroen",nameEn:"May green",hex:"#587F40",rgb:[88,127,64],cmyk:[31,0,50,50]},
  {code:"RAL 6018",name:"Geelgroen",nameEn:"Yellow green",hex:"#60993B",rgb:[96,153,59],cmyk:[37,0,61,40]},
  {code:"RAL 6019",name:"Witgroen",nameEn:"Pastel green",hex:"#B9CEAC",rgb:[185,206,172],cmyk:[10,0,17,19]},
  {code:"RAL 6020",name:"Chroomoxydegroen",nameEn:"Chrome green",hex:"#37422F",rgb:[55,66,47],cmyk:[17,0,29,74]},
  {code:"RAL 6021",name:"Bleekgroen",nameEn:"Pale green",hex:"#8A9977",rgb:[138,153,119],cmyk:[10,0,22,40]},
  {code:"RAL 6022",name:"Bruin olijfgroen",nameEn:"Olive drab",hex:"#3A3327",rgb:[58,51,39],cmyk:[0,12,33,77]},
  {code:"RAL 6024",name:"Verkeersgroen",nameEn:"Traffic green",hex:"#008351",rgb:[0,131,81],cmyk:[100,0,38,49]},
  {code:"RAL 6025",name:"Varengroen",nameEn:"Fern green",hex:"#5E6E3B",rgb:[94,110,59],cmyk:[15,0,46,57]},
  {code:"RAL 6026",name:"Opaalgroen",nameEn:"Opal green",hex:"#005F4E",rgb:[0,95,78],cmyk:[100,0,18,63]},
  {code:"RAL 6027",name:"Lichtgroen",nameEn:"Light green",hex:"#7EBAB5",rgb:[126,186,181],cmyk:[32,0,3,27]},
  {code:"RAL 6028",name:"Pijnboomgroen",nameEn:"Pine green",hex:"#315442",rgb:[49,84,66],cmyk:[42,0,21,67]},
  {code:"RAL 6029",name:"Mintgroen",nameEn:"Mint green",hex:"#006F3D",rgb:[0,111,61],cmyk:[100,0,45,56]},
  {code:"RAL 6032",name:"Signaalgroen",nameEn:"Signal green",hex:"#237F52",rgb:[35,127,82],cmyk:[72,0,35,50]},
  {code:"RAL 6033",name:"Mintturquoise",nameEn:"Mint turquoise",hex:"#45877F",rgb:[69,135,127],cmyk:[49,0,6,47]},
  {code:"RAL 6034",name:"Pastelturquoise",nameEn:"Pastel turquoise",hex:"#7AADAC",rgb:[122,173,172],cmyk:[29,0,1,32]},
  {code:"RAL 6035",name:"Parelmoerdonkergroen",nameEn:"Pearl green",hex:"#194D25",rgb:[25,77,37],cmyk:[68,0,52,70]},
  {code:"RAL 6036",name:"Parelmoerlichtgroen",nameEn:"Pearl opal green",hex:"#04574B",rgb:[4,87,75],cmyk:[95,0,14,66]},
  {code:"RAL 6037",name:"Zuiver groen",nameEn:"Pure green",hex:"#008B29",rgb:[0,139,41],cmyk:[100,0,71,45]},
  {code:"RAL 6038",name:"Briljantgroen",nameEn:"Luminous green",hex:"#00B51B",rgb:[0,181,27],cmyk:[100,0,85,29]},
  {code:"RAL 6039",name:"Fibergroen",nameEn:"Fibrous green",hex:"#B3C43E",rgb:[179,196,62],cmyk:[9,0,68,23]},
  {code:"RAL 7000",name:"Pelsgrijs",nameEn:"Squirrel grey",hex:"#7A888E",rgb:[122,136,142],cmyk:[14,4,0,44]},
  {code:"RAL 7001",name:"Zilvergrijs",nameEn:"Silver grey",hex:"#8C979C",rgb:[140,151,156],cmyk:[10,3,0,39]},
  {code:"RAL 7002",name:"Olijfgrijs",nameEn:"Olive grey",hex:"#817863",rgb:[129,120,99],cmyk:[0,7,23,49]},
  {code:"RAL 7003",name:"Mosgrijs",nameEn:"Moss grey",hex:"#797669",rgb:[121,118,105],cmyk:[0,2,13,53]},
  {code:"RAL 7004",name:"Signaalgrijs",nameEn:"Signal grey",hex:"#9A9B9B",rgb:[154,155,155],cmyk:[1,0,0,39]},
  {code:"RAL 7005",name:"Muisgrijs",nameEn:"Mouse grey",hex:"#6B6E6B",rgb:[107,110,107],cmyk:[3,0,3,57]},
  {code:"RAL 7006",name:"Beigegrijs",nameEn:"Beige grey",hex:"#766A5E",rgb:[118,106,94],cmyk:[0,10,20,54]},
  {code:"RAL 7008",name:"Kakigrijs",nameEn:"Khaki grey",hex:"#745F3D",rgb:[116,95,61],cmyk:[0,18,47,55]},
  {code:"RAL 7009",name:"Groengrijs",nameEn:"Green grey",hex:"#5D6058",rgb:[93,96,88],cmyk:[3,0,8,62]},
  {code:"RAL 7010",name:"Zeildoekgrijs",nameEn:"Tarpaulin grey",hex:"#585C56",rgb:[88,92,86],cmyk:[4,0,7,64]},
  {code:"RAL 7011",name:"IJzergrijs",nameEn:"Iron grey",hex:"#52595D",rgb:[82,89,93],cmyk:[12,4,0,64]},
  {code:"RAL 7012",name:"Bazaltgrijs",nameEn:"Basalt grey",hex:"#575D5E",rgb:[87,93,94],cmyk:[7,1,0,63]},
  {code:"RAL 7013",name:"Bruingrijs",nameEn:"Brown grey",hex:"#575044",rgb:[87,80,68],cmyk:[0,8,22,66]},
  {code:"RAL 7015",name:"Leigrijs",nameEn:"Slate grey",hex:"#4F5358",rgb:[79,83,88],cmyk:[10,6,0,65]},
  {code:"RAL 7016",name:"Antracietgrijs",nameEn:"Anthracite grey",hex:"#383E42",rgb:[56,62,66],cmyk:[15,6,0,74]},
  {code:"RAL 7021",name:"Zwartgrijs",nameEn:"Black grey",hex:"#2F3234",rgb:[47,50,52],cmyk:[10,4,0,80]},
  {code:"RAL 7022",name:"Ombergrijs",nameEn:"Umbra grey",hex:"#4C4A44",rgb:[76,74,68],cmyk:[0,3,11,70]},
  {code:"RAL 7023",name:"Betongrijs",nameEn:"Concrete grey",hex:"#808076",rgb:[128,128,118],cmyk:[0,0,8,50]},
  {code:"RAL 7024",name:"Grafietgrijs",nameEn:"Graphite grey",hex:"#45494E",rgb:[69,73,78],cmyk:[12,6,0,69]},
  {code:"RAL 7026",name:"Granietgrijs",nameEn:"Granite grey",hex:"#374345",rgb:[55,67,69],cmyk:[20,3,0,73]},
  {code:"RAL 7030",name:"Steengrijs",nameEn:"Stone grey",hex:"#928E85",rgb:[146,142,133],cmyk:[0,3,9,43]},
  {code:"RAL 7031",name:"Blauwgrijs",nameEn:"Blue grey",hex:"#5B686D",rgb:[91,104,109],cmyk:[17,5,0,57]},
  {code:"RAL 7032",name:"Kiezelgrijs",nameEn:"Pebble grey",hex:"#B5B0A1",rgb:[181,176,161],cmyk:[0,3,11,29]},
  {code:"RAL 7033",name:"Cementgrijs",nameEn:"Cement grey",hex:"#7F8274",rgb:[127,130,116],cmyk:[2,0,11,49]},
  {code:"RAL 7034",name:"Geelgrijs",nameEn:"Yellow grey",hex:"#92886F",rgb:[146,136,111],cmyk:[0,7,24,43]},
  {code:"RAL 7035",name:"Lichtgrijs",nameEn:"Light grey",hex:"#C5C7C4",rgb:[197,199,196],cmyk:[1,0,2,22]},
  {code:"RAL 7036",name:"Platinagrijs",nameEn:"Platinum grey",hex:"#979392",rgb:[151,147,146],cmyk:[0,3,3,41]},
  {code:"RAL 7037",name:"Stofgrijs",nameEn:"Dusty grey",hex:"#7A7B7A",rgb:[122,123,122],cmyk:[1,0,1,52]},
  {code:"RAL 7038",name:"Agaatgrijs",nameEn:"Agate grey",hex:"#B0B0A9",rgb:[176,176,169],cmyk:[0,0,4,31]},
  {code:"RAL 7039",name:"Kwartsgrijs",nameEn:"Quartz grey",hex:"#6B665E",rgb:[107,102,94],cmyk:[0,5,12,58]},
  {code:"RAL 7040",name:"Venstergrijs",nameEn:"Window grey",hex:"#989EA1",rgb:[152,158,161],cmyk:[6,2,0,37]},
  {code:"RAL 7042",name:"Verkeersgrijs A",nameEn:"Traffic grey A",hex:"#8E9291",rgb:[142,146,145],cmyk:[3,0,1,43]},
  {code:"RAL 7043",name:"Verkeersgrijs B",nameEn:"Traffic grey B",hex:"#4F5250",rgb:[79,82,80],cmyk:[4,0,2,68]},
  {code:"RAL 7044",name:"Zijdegrijs",nameEn:"Silk grey",hex:"#B7B3A8",rgb:[183,179,168],cmyk:[0,2,8,28]},
  {code:"RAL 7045",name:"Telegrijs 1",nameEn:"Telegrey 1",hex:"#8D9295",rgb:[141,146,149],cmyk:[5,2,0,42]},
  {code:"RAL 7046",name:"Telegrijs 2",nameEn:"Telegrey 2",hex:"#7E868A",rgb:[126,134,138],cmyk:[9,3,0,46]},
  {code:"RAL 7047",name:"Telegrijs 4",nameEn:"Telegrey 4",hex:"#C8C8C7",rgb:[200,200,199],cmyk:[0,0,0,22]},
  {code:"RAL 7048",name:"Parelmoermuisgrijs",nameEn:"Pearl mouse grey",hex:"#817B73",rgb:[129,123,115],cmyk:[0,5,11,49]},
  {code:"RAL 8000",name:"Groenbruin",nameEn:"Green brown",hex:"#89693F",rgb:[137,105,63],cmyk:[0,23,54,46]},
  {code:"RAL 8001",name:"Okerbruin",nameEn:"Ochre brown",hex:"#9D622B",rgb:[157,98,43],cmyk:[0,38,73,38]},
  {code:"RAL 8002",name:"Signaalbruin",nameEn:"Signal brown",hex:"#794D3E",rgb:[121,77,62],cmyk:[0,36,49,53]},
  {code:"RAL 8003",name:"Leembruin",nameEn:"Clay brown",hex:"#7E4B27",rgb:[126,75,39],cmyk:[0,40,69,51]},
  {code:"RAL 8004",name:"Koperbruin",nameEn:"Copper brown",hex:"#8D4931",rgb:[141,73,49],cmyk:[0,48,65,45]},
  {code:"RAL 8007",name:"Reebruin",nameEn:"Fawn brown",hex:"#70462B",rgb:[112,70,43],cmyk:[0,38,62,56]},
  {code:"RAL 8008",name:"Olijfbruin",nameEn:"Olive brown",hex:"#724A25",rgb:[114,74,37],cmyk:[0,35,68,55]},
  {code:"RAL 8011",name:"Notenbruin",nameEn:"Nut brown",hex:"#5A3827",rgb:[90,56,39],cmyk:[0,38,57,65]},
  {code:"RAL 8012",name:"Roodbruin",nameEn:"Red brown",hex:"#66332B",rgb:[102,51,43],cmyk:[0,50,58,60]},
  {code:"RAL 8014",name:"Sepiabruin",nameEn:"Sepia brown",hex:"#4A3526",rgb:[74,53,38],cmyk:[0,28,49,71]},
  {code:"RAL 8015",name:"Kastanjebruin",nameEn:"Chestnut brown",hex:"#5E2F26",rgb:[94,47,38],cmyk:[0,50,60,63]},
  {code:"RAL 8016",name:"Mahoniebruin",nameEn:"Mahogany brown",hex:"#4C2B20",rgb:[76,43,32],cmyk:[0,43,58,70]},
  {code:"RAL 8017",name:"Chocoladebruin",nameEn:"Chocolate brown",hex:"#442F29",rgb:[68,47,41],cmyk:[0,31,40,73]},
  {code:"RAL 8019",name:"Grijsbruin",nameEn:"Grey brown",hex:"#3D3635",rgb:[61,54,53],cmyk:[0,11,13,76]},
  {code:"RAL 8022",name:"Zwartbruin",nameEn:"Black brown",hex:"#1A1719",rgb:[26,23,25],cmyk:[0,12,4,90]},
  {code:"RAL 8023",name:"Oranjebruin",nameEn:"Orange brown",hex:"#A45729",rgb:[164,87,41],cmyk:[0,47,75,36]},
  {code:"RAL 8024",name:"Beigebruin",nameEn:"Beige brown",hex:"#795038",rgb:[121,80,56],cmyk:[0,34,54,53]},
  {code:"RAL 8025",name:"Bleekbruin",nameEn:"Pale brown",hex:"#755847",rgb:[117,88,71],cmyk:[0,25,39,54]},
  {code:"RAL 8028",name:"Terrabruin",nameEn:"Terra brown",hex:"#513A2A",rgb:[81,58,42],cmyk:[0,28,48,68]},
  {code:"RAL 8029",name:"Parelmoerkoper",nameEn:"Pearl copper",hex:"#7F4031",rgb:[127,64,49],cmyk:[0,50,61,50]},
  {code:"RAL 9001",name:"Crèmewit",nameEn:"Cream",hex:"#E9E0D2",rgb:[233,224,210],cmyk:[0,4,10,9]},
  {code:"RAL 9002",name:"Grijswit",nameEn:"Grey white",hex:"#D6D5CB",rgb:[214,213,203],cmyk:[0,0,5,16]},
  {code:"RAL 9003",name:"Signaalwit",nameEn:"Signal white",hex:"#ECECE7",rgb:[236,236,231],cmyk:[0,0,2,7]},
  {code:"RAL 9004",name:"Signaalzwart",nameEn:"Signal black",hex:"#2B2B2C",rgb:[43,43,44],cmyk:[2,2,0,83]},
  {code:"RAL 9005",name:"Gitzwart",nameEn:"Jet black",hex:"#0E0E10",rgb:[14,14,16],cmyk:[13,13,0,94]},
  {code:"RAL 9006",name:"Blank aluminiumkleurig",nameEn:"White aluminium",hex:"#A1A1A0",rgb:[161,161,160],cmyk:[0,0,1,37]},
  {code:"RAL 9007",name:"Grijs aluminiumkleurig",nameEn:"Grey aluminium",hex:"#868581",rgb:[134,133,129],cmyk:[0,1,4,47]},
  {code:"RAL 9010",name:"Zuiver wit",nameEn:"Pure white",hex:"#F1EDE1",rgb:[241,237,225],cmyk:[0,2,7,5]},
  {code:"RAL 9011",name:"Grafietzwart",nameEn:"Graphite black",hex:"#27292B",rgb:[39,41,43],cmyk:[9,5,0,83]},
  {code:"RAL 9012",name:"Ultrareine zone wit",nameEn:"Cleanroom white",hex:"#F8F2E1",rgb:[248,242,225],cmyk:[0,2,9,3]},
  {code:"RAL 9016",name:"Verkeerswit",nameEn:"Traffic white",hex:"#F1F1EA",rgb:[241,241,234],cmyk:[0,0,3,5]},
  {code:"RAL 9017",name:"Verkeerszwart",nameEn:"Traffic black",hex:"#29292A",rgb:[41,41,42],cmyk:[2,2,0,84]},
  {code:"RAL 9018",name:"Papyruswit",nameEn:"Papyrus white",hex:"#C8CBC4",rgb:[200,203,196],cmyk:[1,0,3,20]},
  {code:"RAL 9022",name:"Parelmoerlichtgrijs",nameEn:"Pearl light grey",hex:"#858583",rgb:[133,133,131],cmyk:[0,0,2,48]},
  {code:"RAL 9023",name:"Parelmoerdonkergrijs",nameEn:"Pearl dark grey",hex:"#787B7A",rgb:[120,123,122],cmyk:[2,0,1,52]}
];

const POWDER = {
  "RAL 9010":[{merk:"Interpon D2525",code:"AY140E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/90100",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-9010-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 9016":[{merk:"Interpon D2525",code:"AY240E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/90160",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-9016-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 9005":[{merk:"Interpon D2525",code:"ANE40E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/90050",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-9005-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 9006":[{merk:"Interpon D2525",code:"AM140E",afwerking:"Metallic",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/90060",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-9006-ME",afwerking:"Metallic",klasse:"Qualicoat 1"}],
  "RAL 7016":[{merk:"Interpon D2525",code:"AF540E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/70160",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-7016-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 7035":[{merk:"Interpon D2525",code:"AF140E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/70350",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-7035-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 5010":[{merk:"Interpon D2525",code:"AB540E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/50100",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-5010-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 3000":[{merk:"Interpon D2525",code:"AR540E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/30000",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-3000-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 9001":[{merk:"Interpon D2525",code:"AY040E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/90010",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-9001-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
  "RAL 8017":[{merk:"Interpon D2525",code:"AQ540E",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Tiger Drylac",code:"49/80170",afwerking:"Zijdeglans",klasse:"Qualicoat 2"},{merk:"Pulverit",code:"P-8017-SG",afwerking:"Zijdeglans",klasse:"Qualicoat 1"}],
};

// 12 patches: 4 neutrals + 6 chromatics + 2 mid-tones
// More patches = better overdetermined least-squares Lab matrix
const CALIB_PATCHES = [
  // Neutrals (define luminance axis + white-point)
  { id:"white",  label:"RAL 9003", desc:"Signaalwit",     trueRgb:[236,236,231], color:"#ECECE7" },
  { id:"lgrey",  label:"RAL 7035", desc:"Lichtgrijs",     trueRgb:[197,199,196], color:"#C5C7C4" },
  { id:"dgrey",  label:"RAL 7016", desc:"Antracietgrijs", trueRgb:[56,62,66],    color:"#383E42" },
  { id:"black",  label:"RAL 9005", desc:"Gitzwart",       trueRgb:[14,14,16],    color:"#0E0E10" },
  // Primary chromatics (R / G / B axes)
  { id:"red",    label:"RAL 3020", desc:"Verkeersrood",   trueRgb:[187,31,17],   color:"#BB1F11" },
  { id:"green",  label:"RAL 6024", desc:"Verkeersgroen",  trueRgb:[0,131,81],    color:"#008351" },
  { id:"blue",   label:"RAL 5010", desc:"Gentiaanblauw",  trueRgb:[0,79,124],    color:"#004F7C" },
  // Secondary chromatics (Yellow / Orange / Purple)
  { id:"yellow", label:"RAL 1003", desc:"Signaalgeel",    trueRgb:[249,169,0],   color:"#F9A900" },
  { id:"orange", label:"RAL 2009", desc:"Verkeersoranje", trueRgb:[222,83,8],    color:"#DE5308" },
  { id:"purple", label:"RAL 4008", desc:"Signaalviolet",  trueRgb:[132,76,130],  color:"#844C82" },
  // Mid-tones (warm brown + beige - covers iOS WB problem zone)
  { id:"brown",  label:"RAL 8017", desc:"Chocoladebruin", trueRgb:[68,47,41],    color:"#442F29" },
  { id:"beige",  label:"RAL 1001", desc:"Beige",          trueRgb:[208,176,132], color:"#D0B084" },
];

// --- AUTH via Supabase OTP (config above) ------------------------------------

// --- PLAN LIMITS -------------------------------------------------------------
const PLAN = {
  free: {
    label: "Gratis",
    calibration: false,
    powderCodes: false,
    historyMax: 5,
    topMatches: 1,       // only best match shown
    export: false,
  },
  pro: {
    label: "Pro",
    calibration: true,
    powderCodes: true,
    historyMax: 999,
    topMatches: 3,
    export: true,
  },
};

// --- COLOR MATH ---------------------------------------------------------------
function hexToRgb(hex){const h=hex.replace('#','');return[parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)];}
function rgbToHex(r,g,b){return'#'+[r,g,b].map(v=>Math.max(0,Math.min(255,Math.round(v))).toString(16).padStart(2,'0')).join('').toUpperCase();}

// sRGB -> CIE L*a*b* (D65, IEC 61966-2-1)
function rgbToLab(r,g,b){
  let R=r/255,G=g/255,B=b/255;
  R=R>0.04045?Math.pow((R+0.055)/1.055,2.4):R/12.92;
  G=G>0.04045?Math.pow((G+0.055)/1.055,2.4):G/12.92;
  B=B>0.04045?Math.pow((B+0.055)/1.055,2.4):B/12.92;
  const X=(R*0.4124564+G*0.3575761+B*0.1804375)/0.95047;
  const Y=(R*0.2126729+G*0.7151522+B*0.0721750);
  const Z=(R*0.0193339+G*0.1191920+B*0.9503041)/1.08883;
  const f=v=>v>0.008856?Math.cbrt(v):7.787037*v+16/116;
  return[116*f(Y)-16, 500*(f(X)-f(Y)), 200*(f(Y)-f(Z))];
}

// CIEDE2000 - the gold standard for perceptual colour difference
function deltaE2000(lab1,lab2){
  const[L1,a1,b1]=lab1,[L2,a2,b2]=lab2,rad=Math.PI/180;
  const C1=Math.sqrt(a1*a1+b1*b1),C2=Math.sqrt(a2*a2+b2*b2);
  const Cb=(C1+C2)/2,C7=Math.pow(Cb,7),G=0.5*(1-Math.sqrt(C7/(C7+6103515625)));
  const a1p=a1*(1+G),a2p=a2*(1+G);
  const C1p=Math.sqrt(a1p*a1p+b1*b1),C2p=Math.sqrt(a2p*a2p+b2*b2);
  let h1p=Math.atan2(b1,a1p)/rad; if(h1p<0)h1p+=360;
  let h2p=Math.atan2(b2,a2p)/rad; if(h2p<0)h2p+=360;
  const dLp=L2-L1,dCp=C2p-C1p;
  let dhp=0;
  if(C1p*C2p!==0){if(Math.abs(h2p-h1p)<=180)dhp=h2p-h1p;else if(h2p<=h1p)dhp=h2p-h1p+360;else dhp=h2p-h1p-360;}
  const dHp=2*Math.sqrt(C1p*C2p)*Math.sin(dhp/2*rad);
  const Lbp=(L1+L2)/2,Cbp=(C1p+C2p)/2;
  let hbp=h1p+h2p;
  if(C1p*C2p!==0){if(Math.abs(h1p-h2p)<=180)hbp=(h1p+h2p)/2;else if(h1p+h2p<360)hbp=(h1p+h2p+360)/2;else hbp=(h1p+h2p-360)/2;}
  const T=1-0.17*Math.cos((hbp-30)*rad)+0.24*Math.cos(2*hbp*rad)+0.32*Math.cos((3*hbp+6)*rad)-0.20*Math.cos((4*hbp-63)*rad);
  const SL=1+0.015*(Lbp-50)*(Lbp-50)/Math.sqrt(20+(Lbp-50)*(Lbp-50));
  const SC=1+0.045*Cbp,SH=1+0.015*Cbp*T;
  const Cb7p=Math.pow(Cbp,7),RC=2*Math.sqrt(Cb7p/(Cb7p+6103515625));
  const dTheta=30*Math.exp(-((hbp-275)/25)*((hbp-275)/25));
  const RT=-Math.sin(2*dTheta*rad)*RC;
  return Math.sqrt((dLp/SL)*(dLp/SL)+(dCp/SC)*(dCp/SC)+(dHp/SH)*(dHp/SH)+RT*(dCp/SC)*(dHp/SH));
}

function deToConfidence(de){return Math.round(Math.max(0,Math.min(100,100*Math.exp(-de/28))));}

// --- RAL DATABASE LOOKUP ------------------------------------------------------
// Pre-compute Lab for every RAL entry once at load time (fast matching)
const RAL_LAB = RAL.map(r=>rgbToLab(...(r.rgb||hexToRgb(r.hex))));

function findTopRAL(inputLab, n=3){
  // inputLab is already in Lab space (either raw or corrected)
  return RAL
    .map((ral,i)=>({ral, de2000:deltaE2000(inputLab, RAL_LAB[i])}))
    .sort((a,b)=>a.de2000-b.de2000)
    .slice(0,n);
}

// --- COLOUR CORRECTION MATRIX (Lab space) -------------------------------------
// Operates entirely in CIE L*a*b* - never in RGB.
// Solves correctedLab = M x [L, a, b, 1]  (3x4 affine, least squares)
//
// Why Lab and not RGB?
//  * Lab is perceptually uniform: equal dEE = equal perceived difference
//  * A camera white-balance error appears as a shift in the a*-b* plane,
//    which a Lab affine map corrects exactly - an RGB matrix cannot.
//  * Lab corrections generalise better to unseen colours because the
//    space is device-independent.
//
// Reference: Imatest "Color Correction Matrix" (imatest.com/docs/colormatrix)
//            + Lindbloom "Chromatic Adaptation" for the Lab-space rationale
function leastSquares4(A_rows, y_col) {
  // Solve (A'A)w = A'y for w (4-vector), A is nx4
  const n = A_rows.length;
  const AT = Array.from({length:4},()=>Array(n).fill(0));
  for(let r=0;r<4;r++) for(let i=0;i<n;i++) AT[r][i]=A_rows[i][r];
  const ATA=Array.from({length:4},()=>Array(4).fill(0));
  for(let r=0;r<4;r++) for(let c=0;c<4;c++) for(let i=0;i<n;i++) ATA[r][c]+=AT[r][i]*A_rows[i][c];
  const ATy=Array(4).fill(0);
  for(let r=0;r<4;r++) for(let i=0;i<n;i++) ATy[r]+=AT[r][i]*y_col[i];
  // Gaussian elimination with partial pivoting
  const M=ATA.map((row,i)=>[...row,ATy[i]]);
  for(let col=0;col<4;col++){
    let mxR=col; for(let row=col+1;row<4;row++) if(Math.abs(M[row][col])>Math.abs(M[mxR][col])) mxR=row;
    [M[col],M[mxR]]=[M[mxR],M[col]];
    if(Math.abs(M[col][col])<1e-12) continue;
    for(let row=col+1;row<4;row++){const f=M[row][col]/M[col][col];for(let j=col;j<=4;j++) M[row][j]-=f*M[col][j];}
  }
  const w=Array(4).fill(0);
  for(let i=3;i>=0;i--){w[i]=M[i][4];for(let j=i+1;j<4;j++) w[i]-=M[i][j]*w[j]; w[i]/=M[i][i]||1;}
  return w;
}

function buildLabCorrectionMatrix(samples){
  // samples: [{measuredRgb:[r,g,b], trueRgb:[r,g,b]}, ...]
  // Convert both sides to Lab, then fit affine 3x4
  const measuredLabs = samples.map(s=>rgbToLab(...s.measuredRgb));
  const trueLabs     = samples.map(s=>rgbToLab(...s.trueRgb));
  const A_rows = measuredLabs.map(lab=>[...lab,1]); // [L,a,b,1] per row
  return [0,1,2].map(ch=>leastSquares4(A_rows, trueLabs.map(l=>l[ch])));
  // Returns 3 weight-vectors [wL, wa, wb, offset] for L*, a*, b* channels
}

function applyLabMatrix(r,g,b,M){
  // Input: camera RGB -> Output: corrected Lab (ready for CIEDE2000 matching)
  const [L,a,b_]=rgbToLab(r,g,b);
  if(!M) return [L,a,b_];
  return [
    M[0][0]*L + M[0][1]*a + M[0][2]*b_ + M[0][3],
    M[1][0]*L + M[1][1]*a + M[1][2]*b_ + M[1][3],
    M[2][0]*L + M[2][1]*a + M[2][2]*b_ + M[2][3],
  ];
}

// --- STORAGE ------------------------------------------------------------------
const SK='ral_history_v4';
function loadHistory(){try{return JSON.parse(localStorage.getItem(SK))||[];}catch{return[];}}
function saveHistory(h){try{localStorage.setItem(SK,JSON.stringify(h.slice(0,20)));}catch{}}

// --- PROJECTS STORAGE ---------------------------------------------------------
// v0.36: project structure changed from {scans:[...]} to {photos:[{id,imgData,matrix,scans:[...]}]}
// Old projects with direct scans are auto-migrated to a single implicit photo
// v0.36: projecten zijn per user opgeslagen — key bevat userId
function projectKey(userId){ return userId ? 'ral_projects_v1_'+userId : 'ral_projects_v1_guest'; }
function migrateProject(p){
  if(Array.isArray(p.photos)) return p;
  if(Array.isArray(p.scans) && p.scans.length>0){
    return {
      ...p,
      photos: [{id:p.id+'_legacy', imgData:null, matrix:null, scans:p.scans}],
      scans: undefined,
    };
  }
  return {...p, photos: [], scans: undefined};
}
function loadProjects(userId){
  try{
    const raw = JSON.parse(localStorage.getItem(projectKey(userId)))||[];
    return raw.map(migrateProject);
  }catch{return[];}
}
function saveProjects(p, userId){
  try{localStorage.setItem(projectKey(userId),JSON.stringify(p));}catch{}
}
function newProject(name){return{id:Date.now().toString(36),name,date:new Date().toLocaleDateString('nl-BE'),photos:[]};}
function newPhoto(imgData,matrix){return{id:Date.now().toString(36)+Math.random().toString(36).slice(2,6),imgData,matrix:matrix||null,scans:[]};}
// Helper: count total scans across all photos
function projectScanCount(p){
  if(!p?.photos) return 0;
  return p.photos.reduce((sum,ph)=>sum+(ph.scans?.length||0),0);
}

// Bereken localStorage gebruik in bytes via Blob (accuraat voor base64)
function getLocalStorageUsage(){
  try {
    return new Blob(Object.values(localStorage)).size;
  } catch {
    // Fallback als Blob niet beschikbaar is
    let total = 0;
    for(let key in localStorage){
      if(!localStorage.hasOwnProperty(key)) continue;
      total += localStorage[key].length + key.length;
    }
    return total;
  }
}
const LS_MAX_BYTES  = 4.5 * 1024 * 1024; // 4.5MB — weiger nieuwe foto's
const LS_WARN_BYTES = 3.5 * 1024 * 1024; // 3.5MB — toon waarschuwing

// Comprimeer een foto naar max 800px breed/hoog, JPEG 0.72
// Reduceert opslag van 2-5MB naar 50-150KB zonder impact op scannauwkeurigheid
function compressImage(dataUrl, maxSize=1200, quality=0.85){
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let {width, height} = img;
      if(width > maxSize || height > maxSize){
        if(width > height){ height = Math.round(height * maxSize / width); width = maxSize; }
        else { width = Math.round(width * maxSize / height); height = maxSize; }
      }
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = () => resolve(dataUrl); // bij fout: origineel teruggeven
    img.src = dataUrl;
  });
}

// --- ICONS --------------------------------------------------------------------
const IconLock = ({size=14,color='currentColor'}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const IconSun = ({color}) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);
const IconMoon = ({color}) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);


// --- COMPONENT ----------------------------------------------------------------
export default function App() {
  const canvasRef      = useRef(null);
  const fileInputRef   = useRef(null);
  const cameraInputRef = useRef(null);
  const fireSelectionRef  = useRef(null);
  const activeProjRef     = useRef(null);
  const matrixRef         = useRef(null);
  const imgDataRef        = useRef(null);
  const calibModeRef      = useRef(false);
  const calibStepRef      = useRef(0);
  const calibSamplesRef   = useRef([]);
  const materialRef       = useRef('alu');
  const planRef           = useRef(null);
  const lastTouchRef      = useRef(0);

  // -- Auth state --------------------------------------------------------------
  const [authStep,     setAuthStep]     = useState('email');  // 'email'|'code'
  const [authEmail,    setAuthEmail]    = useState('');
  const [authCode,     setAuthCode]     = useState('');
  const [authError,    setAuthError]    = useState('');
  const [authLoading,  setAuthLoading]  = useState(false);
  const [user,         setUser]         = useState(null);     // {email, name, plan}
  const [authReady,    setAuthReady]    = useState(false);
  const [sessionKicked,setSessionKicked]= useState(false);   // true wanneer sessie verdrongen door ander apparaat
  const [sessionKickedByPoll,setSessionKickedByPoll]= useState(false); // true wanneer poll een andere token detecteert
  const [signOutLoading,setSignOutLoading]=useState(false);  // guard: voorkomt dubbele signOut calls

  // -- App state ---------------------------------------------------------------
  const [imgData,      setImgData]      = useState(null);
  const [crosshair,    setCrosshair]    = useState(null);
  const [liveCross,    setLiveCross]    = useState(null);
  const [scannedColor, setScannedColor] = useState(null);
  const [topResults,   setTopResults]   = useState([]);
  const [selectedIdx,  setSelectedIdx]  = useState(0);
  const [history,      setHistory]      = useState(loadHistory);
  const [copied,       setCopied]       = useState(null);
  const [tab,          setTab]          = useState('scan');
  // Pinch-zoom state
  const [pinchScale,  setPinchScale]  = useState(1);
  const [pinchOrigin, setPinchOrigin] = useState({x:50,y:50}); // % for transform-origin
  const pinchStartDist = useRef(0);
  const pinchStartScale = useRef(1);
  const isPinchingRef  = useRef(false);  // blijft true tot 120ms na pinch-einde, voorkomt naijlend touchend
  const [powderOpen,   setPowderOpen]   = useState(false);
  const [dark,         setDark]         = useState(true);
  const [material,     setMaterial]     = useState('alu');
  const [showUpgrade,  setShowUpgrade]  = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [calibMode,    setCalibMode]    = useState(false);
  const [calibStep,    setCalibStep]    = useState(0);
  const [calibSamples, setCalibSamples] = useState([]);
  const [matrix,       setMatrix]       = useState(null);
  const [calibDone,    setCalibDone]    = useState(false);

  // -- Project state ------------------------------------------------------------
  const [projects,      setProjects]     = useState(()=>loadProjects(null));
  const [activeProject, setActiveProject]= useState(null);
  const [showNewProj,   setShowNewProj]  = useState(false);
  const [newProjName,   setNewProjName]  = useState('');
  const [scanNote,      setScanNote]     = useState('');
  const [collapsedProj, setCollapsedProj]= useState({});    // {id: true=collapsed, false=open}
  const [swipeOffset,   setSwipeOffset]  = useState({});    // {projId_scanIdx: offsetX}
  // v0.36: photo session state
  const [activePhotoId, setActivePhotoId]= useState(null);  // id van actieve foto in actief project
  const [renamingProj,  setRenamingProj] = useState(null);  // {id, name} bij rename modal
  const [renameName,    setRenameName]   = useState('');
  const activePhotoIdRef = useRef(null);
  const galleryInputRef  = useRef(null);
  const [paymentSuccess,setPaymentSuccess]=useState(false); // true na Stripe redirect met ?payment=success
  // storageWarning wordt berekend als afgeleide waarde bij elke render (zie hieronder)
  const swipeTouchStart = useRef({});    // {key: {x, y, scrollY}}
  const swipeScrolled   = useRef({});    // {key: true} — cancel swipe if scrolled
  const lastProfileFetch= useRef(0);     // timestamp laatste loadProfile — throttle visibilitychange
  const sessionTokenRef = useRef(null);  // anti-sharing: token in memory
  const sessionPollRef  = useRef(null);  // interval handle voor session poll
  matrixRef.current        = matrix;
  imgDataRef.current       = imgData;
  activePhotoIdRef.current = activePhotoId;
  calibModeRef.current     = calibMode;
  calibStepRef.current     = calibStep;
  calibSamplesRef.current  = calibSamples;
  materialRef.current      = material;
  activeProjRef.current   = activeProject;

  // -- Derived plan ------------------------------------------------------------
  const plan = user ? PLAN[user.plan] : null;
  const now = new Date();
  const subEnd = user?.subscriptionEnd ? new Date(user.subscriptionEnd) : null;
  const isPro = user?.plan === 'pro' && (
    user?.subscriptionStatus !== 'cancelled' || (subEnd && subEnd > now)
  );
  const isCancelled   = user?.subscriptionStatus === 'cancelled' && isPro;
  const cancelEndDate = subEnd
    ? subEnd.toLocaleDateString('nl-BE', {day:'numeric', month:'long', year:'numeric'})
    : null;
  planRef.current = plan; // keep ref in sync

  // -- Theme -------------------------------------------------------------------
  const T = dark ? {
    bg:'#0d0d0d',surface:'#161616',surface2:'#1c1c1c',border:'#222',
    text:'#f0ede8',textMuted:'#9a9a9a',textFaint:'#3a3a3a',accent:'#e8d5b0',
    btnPrimary:'#e8d5b0',btnPrimaryText:'#111',btnSecondary:'#181818',btnSecBorder:'#2a2a2a',
    cardBg:'#141414',cardBorder:'#1e1e1e',divider:'#1e1e1e',hintBg:'rgba(0,0,0,0.75)',
    crosshair:'rgba(255,255,255,0.45)',swatchBorder:'rgba(255,255,255,0.08)',
    green:'#7ec87e',greenBg:'#1a3a1a',greenBorder:'#2e5e2e',
    amber:'#d4a84b',amberBg:'#3a2e1a',
    red:'#d46b6b',redBg:'#3a1a1a',
    goodBg:'#1e321a',toggleBg:'#1e1e1e',
    inputBg:'#111',inputBorder:'#2a2a2a',
    lockOverlay:'rgba(13,13,13,0.82)',
    proGold:'#f0c060',proGoldBg:'#2a2010',
  } : {
    bg:'#f4f3ef',surface:'#ffffff',surface2:'#f0efe8',border:'#ddd',
    text:'#1a1a1a',textMuted:'#555',textFaint:'#bbb',accent:'#7a5c20',
    btnPrimary:'#2a2a2a',btnPrimaryText:'#f4f3ef',btnSecondary:'#fff',btnSecBorder:'#ccc',
    cardBg:'#ffffff',cardBorder:'#e0ddd8',divider:'#e8e5e0',hintBg:'rgba(0,0,0,0.65)',
    crosshair:'rgba(0,0,0,0.4)',swatchBorder:'rgba(0,0,0,0.1)',
    green:'#2a7a2a',greenBg:'#e8f5e8',greenBorder:'#b8d8b8',
    amber:'#8a5a00',amberBg:'#fff5e0',
    red:'#c0392b',redBg:'#fde8e8',
    goodBg:'#e0f0e0',toggleBg:'#e8e5e0',
    inputBg:'#fafafa',inputBorder:'#ccc',
    lockOverlay:'rgba(244,243,239,0.85)',
    proGold:'#a07020',proGoldBg:'#fff5e0',
  };

  const mono = {fontFamily:"'DM Mono',monospace"};
  const lbl  = {...mono,fontSize:'0.6rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textMuted,display:'block',marginBottom:3};

  // -- Auth handlers ------------------------------------------------------------
  useEffect(() => {
    const client = supabase;

    // Check ?payment=success in URL — toon bevestigingsbanner
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment') === 'success') {
      setPaymentSuccess(true);
      // Verwijder de query param uit de URL zonder pagina te herladen
      window.history.replaceState({}, '', window.location.pathname);
    }

    // Safety timeout: nooit langer dan 4 seconden hangen op 'Laden...'
    const safetyTimer = setTimeout(() => setAuthReady(true), 4000);

    client.auth.getSession().then(async ({ data: { session } }) => {
      clearTimeout(safetyTimer);
      if (session && session.user) {
        lastProfileFetch.current = Date.now();
        await loadProfile(client, session.user);
      }
      setAuthReady(true);
    }).catch(() => {
      clearTimeout(safetyTimer);
      setAuthReady(true);
    });

    const { data: { subscription } } = client.auth.onAuthStateChange(
      async (event, session) => {
        if (event === 'SIGNED_IN' && session && session.user) {
          lastProfileFetch.current = Date.now();
          await loadProfile(client, session.user);
          setAuthReady(true);
        } else if (event === 'SIGNED_OUT') {
          // Alleen resetten als we niet zelf aan het uitloggen zijn via signOut()
          setUser(null);
        } else if (event === 'TOKEN_REFRESHED' && !session) {
          // Sessie geïnvalideerd door ander apparaat (anti-sharing)
          setUser(null);
          setSessionKicked(true);
        }
      }
    );

    // iOS Safari: hercheck sessie wanneer tab terug actief wordt
    // Throttle: max 1x per 5 minuten — voorkomt onnodige Supabase queries
    const handleVisibility = () => {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastProfileFetch.current < 5 * 60 * 1000) return;
      lastProfileFetch.current = now;
      client.auth.getSession().then(async ({ data: { session } }) => {
        if (session && session.user) await loadProfile(client, session.user);
        else setUser(null);
        setAuthReady(true);
      }).catch(() => setAuthReady(true));
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearTimeout(safetyTimer);
      subscription.unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  const startSessionPoll = (client, userId) => {
    // Verwijder eventueel bestaand interval
    if (sessionPollRef.current) clearInterval(sessionPollRef.current);
    sessionPollRef.current = setInterval(async () => {
      // Geen token in memory = niet ingelogd, stop poll
      if (!sessionTokenRef.current) {
        clearInterval(sessionPollRef.current);
        return;
      }
      try {
        const { data } = await client
          .from('profiles')
          .select('session_token, last_seen_at')
          .eq('id', userId)
          .single();
        // Update last_seen_at bij elke poll — goedkoop en nuttig voor analytics
        client.from('profiles')
          .update({ last_seen_at: new Date().toISOString() })
          .eq('id', userId)
          .then(() => {});
        // Token verschilt = andere sessie heeft ingelogd
        // Sla over als onze token nog niet gezet is (race condition bij startup)
        if (!sessionTokenRef.current) return;
        if (data?.session_token && data.session_token !== sessionTokenRef.current) {
          clearInterval(sessionPollRef.current);
          sessionTokenRef.current = null;
          setSessionKickedByPoll(true);
          // 3 seconden melding tonen, dan uitloggen
          setTimeout(async () => {
            const c = sb();
            if (c) await c.auth.signOut().catch(() => {});
            setUser(null);
            setAuthStep('email'); setAuthEmail(''); setAuthCode('');
            setAuthError(''); setImgData(null); setTopResults([]);
            setScannedColor(null); setCrosshair(null); setMatrix(null); setCalibDone(false);
            setShowSettings(false); setShowUpgrade(false);
            setSessionKickedByPoll(false);
            setSessionKicked(true); // toon melding op loginscherm
          }, 3000);
        }
      } catch {
        // Netwerkfout: stil falen, poll gewoon verder
      }
    }, 30000); // elke 30 seconden
  };

  const loadProfile = async (client, sbUser, retryCount = 0) => {
    try {
      const { data, error } = await client
        .from('profiles')
        .select('plan, subscription_status, subscription_end')
        .eq('id', sbUser.id)
        .single();

      if (error) {
        // PGRST116 = geen rij gevonden — profiel bestaat nog niet
        if (error.code === 'PGRST116') {
          // Maak een nieuw profiel aan voor deze user
          await client.from('profiles').insert({
            id: sbUser.id,
            email: sbUser.email,
            plan: 'free',
            subscription_status: 'none',
          }).then(() => {});
        } else if (retryCount < 2) {
          // Andere fout (netwerk, timing) — wacht 1 seconde en probeer opnieuw
          await new Promise(r => setTimeout(r, 1000));
          return loadProfile(client, sbUser, retryCount + 1);
        }
        // Na retries: toon free als fallback maar log de fout
        console.warn('loadProfile error:', error.code, error.message);
        setUser({ email: sbUser.email, name: sbUser.email.split('@')[0], plan: 'free', subscriptionStatus: 'none', subscriptionEnd: null, id: sbUser.id });
        return;
      }

      // Anti-sharing: genereer nieuw session_token bij elke login/profile load
      const newToken = crypto.randomUUID();
      sessionTokenRef.current = newToken;
      client.from('profiles')
        .update({ session_token: newToken, last_seen_at: new Date().toISOString() })
        .eq('id', sbUser.id)
        .then(() => {});

      setUser({
        email:              sbUser.email,
        name:               sbUser.email.split('@')[0],
        plan:               data?.plan                || 'free',
        subscriptionStatus: data?.subscription_status || 'none',
        subscriptionEnd:    data?.subscription_end    || null,
        id:                 sbUser.id,
      });

      // Start session polling als die nog niet loopt
      startSessionPoll(client, sbUser.id);
    } catch (err) {
      console.warn('loadProfile exception:', err);
      if (retryCount < 2) {
        await new Promise(r => setTimeout(r, 1000));
        return loadProfile(client, sbUser, retryCount + 1);
      }
      setUser({ email: sbUser.email, name: sbUser.email.split('@')[0], plan: 'free', subscriptionStatus: 'none', subscriptionEnd: null, id: sbUser.id });
    }
  };

  const sendCode = async () => {
    const email = authEmail.trim().toLowerCase();
    if (!email.includes('@')) { setAuthError('Vul een geldig e-mailadres in.'); return; }
    const client = sb();
    if (!client) { setAuthError('App laden mislukt. Herlaad de pagina.'); return; }
    setAuthLoading(true); setAuthError('');
    const { error } = await client.auth.signInWithOtp({ email, options: { shouldCreateUser: true } });
    setAuthLoading(false);
    if (error) { setAuthError(error.message); return; }
    setAuthStep('code');
  };

  const verifyCode = async () => {
    const token = authCode.trim();
    if (token.length !== 6) { setAuthError('Vul de 6-cijferige code in.'); return; }
    const client = sb();
    if (!client) { setAuthError('App laden mislukt. Herlaad de pagina.'); return; }
    setAuthLoading(true); setAuthError('');

    // Try 'email' type first, fall back to 'magiclink' if that fails
    let result = await client.auth.verifyOtp({
      email: authEmail.trim().toLowerCase(), token, type: 'email',
    });

    if (result.error) {
      // Supabase soms registreert OTP als 'magiclink' type — probeer beide
      result = await client.auth.verifyOtp({
        email: authEmail.trim().toLowerCase(), token, type: 'magiclink',
      });
    }

    if (result.error) {
      setAuthLoading(false);
      setAuthError('Onjuiste of verlopen code. Probeer opnieuw.');
      return;
    }

    // Don't rely solely on onAuthStateChange — explicitly fetch session
    // This fixes the 'stuck on Controleren...' issue with custom SMTP
    const { data: { session } } = await client.auth.getSession();
    if (session && session.user) {
      await loadProfile(client, session.user);
      setAuthReady(true); // forceer re-render zodat app zichtbaar wordt zonder refresh
      setSessionKicked(false);       // Bug 4: reset "Sessie beëindigd" melding bij nieuwe login
      setSessionKickedByPoll(false);
    }
    setAuthLoading(false);
  };

  const signOut = async () => {
    // Guard: voorkomt dubbele calls en race condition met visibilitychange
    if (signOutLoading) return;
    setSignOutLoading(true);
    // Stop session poll en clear token
    if (sessionPollRef.current) { clearInterval(sessionPollRef.current); sessionPollRef.current = null; }
    sessionTokenRef.current = null;
    const client = sb();
    try {
      if (client) await client.auth.signOut();
    } catch {
      // Negeer Supabase fouten bij uitloggen — sessie lokaal opruimen is genoeg
    }
    setUser(null);
    setAuthStep('email'); setAuthEmail(''); setAuthCode('');
    setAuthError(''); setImgData(null); setTopResults([]);
    setScannedColor(null); setCrosshair(null); setMatrix(null); setCalibDone(false);
    setShowSettings(false); setShowUpgrade(false);
    setSignOutLoading(false);
  };

  // Bug 5 fix: herlaad projecten bij account wissel + quota check
  useEffect(() => {
    const userId = user?.id || null;
    setProjects(loadProjects(userId));
    setActiveProject(null);
    setActivePhotoId(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  // -- Pro gate helper -----------------------------------------------------------
  const proGate = (action) => {
    if(isPro) { action(); }
    else { setShowUpgrade(true); }
  };

  // -- Delta colour helper -------------------------------------------------------
  const dc = (de) => {
    if(de<3)  return {fg:T.green,bg:T.greenBg,label:'Uitstekend'};
    if(de<6)  return {fg:T.green,bg:T.goodBg, label:'Goed'};
    if(de<10) return {fg:T.amber,bg:T.amberBg,label:'Aanvaardbaar'};
    return          {fg:T.red,  bg:T.redBg,  label:'Indicatief'};
  };

  const merkColors = {
    "Interpon D2525":{bg:dark?"#1a2e4a":"#deeaf8",fg:dark?"#5b9bd5":"#1a5a9a",dot:"#2196F3"},
    "Tiger Drylac":  {bg:dark?"#2e1a1a":"#fae8e8",fg:dark?"#d57b5b":"#9a2a1a",dot:"#FF5722"},
    "Pulverit":      {bg:dark?"#1a2e1a":"#e8f5e8",fg:dark?"#6db86d":"#2a7a2a",dot:"#4CAF50"},
  };

  // -- File load -----------------------------------------------------------------
  // Verwerk een enkele foto (van camera of gallery single-pick)
  const handleFile = useCallback((file) => {
    if(!file||!file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onload = e => {
      handleSingleImageLoaded(e.target.result);
    };
    reader.readAsDataURL(file);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Verwerk meerdere foto's tegelijk (gallery multi-select)
  const handleMultipleFiles = useCallback((fileList) => {
    const files = Array.from(fileList || []).filter(f => f.type.startsWith('image/'));
    if(files.length === 0) return;
    if(files.length === 1){ handleFile(files[0]); return; }
    // Lees alle files parallel, voeg ze toe in volgorde
    Promise.all(files.map(f => new Promise(res => {
      const r = new FileReader();
      r.onload = e => res(e.target.result);
      r.readAsDataURL(f);
    }))).then(results => {
      handleMultiImagesLoaded(results);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleFile]);

  // Een enkele foto geladen — comprimeer en sla op
  const handleSingleImageLoaded = async (dataUrl) => {
    setSelectedIdx(0); setPowderOpen(false); setCalibMode(false); setCalibStep(0);
    // Laad de originele foto meteen in de scanner voor snelle weergave
    setImgData(dataUrl);
    setMatrix(null); matrixRef.current=null; setCalibDone(false); setCalibSamples([]);
    setTopResults([]); setScannedColor(null); setCrosshair(null); setPinchScale(1);

    if(activeProjRef.current){
      // Comprimeer op achtergrond voor opslag in localStorage
      const compressed = await compressImage(dataUrl);

      // Quota check: weiger opslag als localStorage vol is (storageFull herberekend bij render)
      if(new Blob(Object.values(localStorage)).size > LS_MAX_BYTES){
        setActivePhotoId(null);
        return;
      }

      const photo = newPhoto(compressed, null);
      setProjects(prev => {
        const next = prev.map(p => p.id===activeProjRef.current
          ? {...p, photos:[...(p.photos||[]), photo]}
          : p);
        saveProjects(next, user?.id);
        return next;
      });
      setActivePhotoId(photo.id);
      // Vervang ook de scanner foto door de gecomprimeerde versie
      setImgData(compressed);
    } else {
      setActivePhotoId(null);
    }
  };

  // Meerdere foto's geladen — comprimeer en voeg toe aan project
  const handleMultiImagesLoaded = async (dataUrls) => {
    setSelectedIdx(0); setPowderOpen(false); setCalibMode(false); setCalibStep(0);
    // Laad eerste foto meteen voor snelle weergave
    setImgData(dataUrls[0]);
    setMatrix(null); matrixRef.current=null; setCalibDone(false); setCalibSamples([]);
    setTopResults([]); setScannedColor(null); setCrosshair(null); setPinchScale(1);

    if(activeProjRef.current){
      // Comprimeer alle foto's parallel
      const compressedUrls = await Promise.all(dataUrls.map(d => compressImage(d)));

      // Quota check
      if(new Blob(Object.values(localStorage)).size > LS_MAX_BYTES){
        setActivePhotoId(null);
        return;
      }

      const newPhotos = compressedUrls.map(d => newPhoto(d, null));
      setProjects(prev => {
        const next = prev.map(p => p.id===activeProjRef.current
          ? {...p, photos:[...(p.photos||[]), ...newPhotos]}
          : p);
        saveProjects(next, user?.id);
        return next;
      });
      setActivePhotoId(newPhotos[0].id);
      // Vervang ook de scanner foto door gecomprimeerde versie
      setImgData(compressedUrls[0]);
    } else {
      setActivePhotoId(null);
    }
  };

  // -- Pixel sampler -------------------------------------------------------------
  const samplePixel = useCallback((rx,ry,imgEl) => {
    const canvas = canvasRef.current;
    canvas.width = imgEl.naturalWidth; canvas.height = imgEl.naturalHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(imgEl,0,0);
    const px = Math.floor(rx*imgEl.naturalWidth);
    const py = Math.floor(ry*imgEl.naturalHeight);
    const sz = Math.max(8,Math.floor(imgEl.naturalWidth*0.012)); // larger area = better noise reduction
    const x0 = Math.max(0,px-sz), y0 = Math.max(0,py-sz);
    const w  = Math.min(sz*2,imgEl.naturalWidth-x0);
    const h  = Math.min(sz*2,imgEl.naturalHeight-y0);
    const d  = ctx.getImageData(x0,y0,w,h).data;
    let r=0,g=0,b=0,n=0;
    for(let i=0;i<d.length;i+=4){r+=d[i];g+=d[i+1];b+=d[i+2];n++;}
    return[Math.round(r/n),Math.round(g/n),Math.round(b/n)];
  }, []);

  // -- Touch handlers ------------------------------------------------------------
  const getRel = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const t = (e.touches && e.touches[0]) || e;
    return {
      rx: Math.max(0,Math.min(1,(t.clientX-rect.left)/rect.width)),
      ry: Math.max(0,Math.min(1,(t.clientY-rect.top)/rect.height)),
    };
  };
  const handleTouchStart = useCallback((e) => {
    e.preventDefault(); lastTouchRef.current = Date.now();
    const {rx,ry} = getRel(e); setLiveCross({rx,ry});
  }, []);
  const handleTouchMove = useCallback((e) => {
    e.preventDefault(); const {rx,ry} = getRel(e); setLiveCross({rx,ry});
  }, []);
  const handleTouchEnd = useCallback((e) => {
    e.preventDefault();
    setLiveCross(prev => { if(prev) setTimeout(()=>fireSelectionRef.current(prev.rx,prev.ry),0); return null; });
  }, []);
  const handleClick = useCallback((e) => {
    if(Date.now()-lastTouchRef.current<600) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const rx = Math.max(0,Math.min(1,(e.clientX-rect.left)/rect.width));
    const ry = Math.max(0,Math.min(1,(e.clientY-rect.top)/rect.height));
    fireSelectionRef.current(rx,ry);
  }, []);

  // -- Fire selection - reads ONLY from refs, never stale -----------------------
  const fireSelection = useCallback((rx,ry) => {
    const img = new Image();
    img.onload = () => {
      const _calibMode    = calibModeRef.current;
      const _calibStep    = calibStepRef.current;
      const _calibSamples = calibSamplesRef.current;
      const _imgData      = imgDataRef.current;
      if(!_imgData) return;
      if(_calibMode) {
        const measured   = samplePixel(rx,ry,img);
        const patch      = CALIB_PATCHES[_calibStep];
        const newSamples = [..._calibSamples, {measured, true:patch.trueRgb}];
        if(_calibStep < CALIB_PATCHES.length-1) {
          setCalibSamples(newSamples); setCalibStep(_calibStep+1);
        } else {
          // Build 3x4 colour correction matrix in Lab space
          const labSamples = newSamples.map(s=>({measuredRgb:s.measured, trueRgb:s.true}));
          const m = buildLabCorrectionMatrix(labSamples);
          matrixRef.current = m;
          setMatrix(m);
          setCalibSamples(newSamples); setCalibMode(false); setCalibDone(true);
        }
        return;
      }
      setCrosshair({x:rx,y:ry});
      const [r,g,b] = samplePixel(rx,ry,img);
      // Convert to corrected Lab - all subsequent work stays in Lab space
      const correctedLab = applyLabMatrix(r,g,b,matrixRef.current);
      const hex = rgbToHex(r,g,b); // keep original hex for visual display only
      const p   = planRef.current;
      const top = findTopRAL(correctedLab, 3);
      setScannedColor(hex); setTopResults(top); setSelectedIdx(0); setPowderOpen(false);
      // v0.36: geen automatische opslag — enkel resultaten tonen
      // Gebruiker moet expliciet "Opslaan in project" klikken
      // Note: scanNote staat al in state, blijft bewaard tot expliciete opslag of nieuwe scan
      setScanNote('');
    };
    img.src = imgDataRef.current;
  }, [samplePixel]);
  fireSelectionRef.current = fireSelection;

  const copyCode = (code) => {navigator.clipboard?.writeText(code).catch(()=>{});setCopied(code);setTimeout(()=>setCopied(null),1800);};

  // -- v0.36: Photo management helpers ----------------------------------------
  // Voeg een nieuwe foto toe aan het actieve project (of laad voor sessie zonder project)
  const addPhotoToActiveProject = (imgDataUrl) => {
    if(activeProjRef.current){
      // Foto opslaan in actief project
      const photo = newPhoto(imgDataUrl, null);
      setProjects(prev=>{
        const next = prev.map(p => p.id===activeProjRef.current
          ? {...p, photos:[...(p.photos||[]), photo]}
          : p);
        saveProjects(next, user?.id);
        return next;
      });
      // Activeer de nieuwe foto
      setActivePhotoId(photo.id);
      setImgData(imgDataUrl);
      // Reset kalibratie en scan-state voor de nieuwe foto
      setMatrix(null); matrixRef.current=null; setCalibDone(false); setCalibSamples([]);
      setTopResults([]); setScannedColor(null); setCrosshair(null); setPinchScale(1);
    } else {
      // Geen actief project: laad gewoon de foto in de scanner zonder opslag
      setActivePhotoId(null);
      setImgData(imgDataUrl);
      setMatrix(null); matrixRef.current=null; setCalibDone(false); setCalibSamples([]);
      setTopResults([]); setScannedColor(null); setCrosshair(null); setPinchScale(1);
    }
  };

  // Switch naar een andere foto in het actieve project
  const switchToPhoto = (photoId) => {
    if(!activeProjRef.current) return;
    const proj = projects.find(p => p.id===activeProjRef.current);
    if(!proj) return;
    const photo = (proj.photos||[]).find(ph => ph.id===photoId);
    if(!photo) return;
    setActivePhotoId(photoId);
    setImgData(photo.imgData);
    // Laad opgeslagen kalibratiematrix
    if(photo.matrix){
      setMatrix(photo.matrix); matrixRef.current=photo.matrix;
      setCalibDone(true);
    } else {
      setMatrix(null); matrixRef.current=null; setCalibDone(false);
    }
    // Reset transient scan state
    setTopResults([]); setScannedColor(null); setCrosshair(null); setPinchScale(1);
    setCalibMode(false); setCalibSamples([]);
  };

  // Verwijder een foto uit het actieve project
  const removePhoto = (photoId) => {
    if(!activeProjRef.current) return;
    setProjects(prev=>{
      const next = prev.map(p => p.id===activeProjRef.current
        ? {...p, photos:(p.photos||[]).filter(ph => ph.id!==photoId)}
        : p);
      saveProjects(next, user?.id);
      return next;
    });
    // Als de actieve foto verwijderd werd, kies een andere of leeg
    if(activePhotoId===photoId){
      const proj = projects.find(p => p.id===activeProjRef.current);
      const remaining = (proj?.photos||[]).filter(ph => ph.id!==photoId);
      if(remaining.length>0){
        switchToPhoto(remaining[0].id);
      } else {
        setActivePhotoId(null);
        setImgData(null);
        setMatrix(null); matrixRef.current=null; setCalibDone(false);
        setTopResults([]); setScannedColor(null); setCrosshair(null);
      }
    }
  };

  // Wanneer kalibratie voltooid wordt, sla matrix op in de actieve foto
  // (dit gebeurt via een useEffect omdat fireSelection async werkt)
  useEffect(() => {
    if(calibDone && matrix && activePhotoId && activeProjRef.current){
      setProjects(prev=>{
        const next = prev.map(p => p.id===activeProjRef.current
          ? {...p, photos:(p.photos||[]).map(ph =>
              ph.id===activePhotoId ? {...ph, matrix} : ph)}
          : p);
        saveProjects(next, user?.id);
        return next;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calibDone, matrix, activePhotoId]);

  // Sla huidige scan op in actieve foto van actief project
  const saveScanToProject = () => {
    if(!activeProjRef.current || !sel) return;
    const entry = {
      hex: scannedColor,
      ral: sel.ral,
      de2000: sel.de2000,
      confidence: deToConfidence(sel.de2000),
      material: materialRef.current,
      date: new Date().toLocaleDateString('nl-BE'),
      calibrated: !!matrixRef.current,
      note: scanNote.trim() || undefined,
    };
    // Update global history
    setHistory(prev => {
      const next = [entry, ...prev.filter(h => h.hex!==entry.hex)].slice(0, plan?.historyMax||5);
      saveHistory(next);
      return next;
    });
    // Voeg toe aan actieve foto, of als er geen actieve foto is, maak een impliciete foto
    setProjects(prev => {
      const next = prev.map(p => {
        if(p.id !== activeProjRef.current) return p;
        const photos = p.photos || [];
        if(activePhotoIdRef.current){
          // Voeg toe aan bestaande foto
          return {...p, photos: photos.map(ph =>
            ph.id===activePhotoIdRef.current
              ? {...ph, scans:[...(ph.scans||[]), entry]}
              : ph)};
        } else {
          // Geen actieve foto — maak een impliciete foto met de huidige imgData
          const implicit = newPhoto(imgDataRef.current || null, matrixRef.current);
          implicit.scans = [entry];
          // Sla ook de activePhotoId in zodat volgende scans correct worden gekoppeld
          setActivePhotoId(implicit.id);
          return {...p, photos: [...photos, implicit]};
        }
      });
      saveProjects(next, user?.id);
      return next;
    });
    // Reset scan state na opslag
    setTopResults([]); setScannedColor(null); setCrosshair(null);
    setScanNote('');
  };

  // Hernoem project
  const renameProject = (projId, newName) => {
    const trimmed = newName.trim();
    if(!trimmed) return;
    setProjects(prev=>{
      const next = prev.map(p => p.id===projId ? {...p, name:trimmed} : p);
      saveProjects(next, user?.id);
      return next;
    });
  };


  // Quota check — berekend op basis van projects state (synchroon, altijd correct)
  // Schat de grootte van alle foto's in alle projecten
  const estimatedPhotoBytes = projects.reduce((total, p) =>
    total + (p.photos||[]).reduce((sum, ph) =>
      sum + (ph.imgData ? ph.imgData.length : 0), 0), 0);
  // Voeg vaste overhead toe voor auth tokens en project metadata (~200KB)
  const storageUsage   = estimatedPhotoBytes + 200 * 1024;
  const storageWarning = storageUsage > LS_WARN_BYTES;
  const storageFull    = storageUsage > LS_MAX_BYTES;

  const sel = topResults[selectedIdx];
  const powderCodes = sel ? (POWDER[sel.ral.code]||[]) : [];

  // -- Shared input style --------------------------------------------------------
  const inputStyle = {
    width:'100%', background:T.inputBg, border:`1px solid ${T.inputBorder}`,
    borderRadius:8, color:T.text, ...mono, fontSize:'1rem', padding:'13px 14px',
    outline:'none', boxSizing:'border-box',
  };
  const primaryBtn = {
    width:'100%', background:T.btnPrimary, color:T.btnPrimaryText, border:'none',
    borderRadius:8, padding:'14px', fontFamily:"'Bebas Neue',sans-serif",
    fontSize:'1.2rem', letterSpacing:'0.08em', cursor:'pointer',
  };

  // ==============================================================================
  // AUTH SCREEN
  // ==============================================================================
  if (!authReady) return (
    <div style={{background:T.bg,minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{fontFamily:"'DM Mono',monospace",fontSize:'0.72rem',color:T.textMuted,letterSpacing:'0.12em'}}>Laden...</div>
    </div>
  );

  if(!user) return (
    <div style={{background:T.bg,minHeight:'100vh',color:T.text,fontFamily:'system-ui,sans-serif',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'24px 20px',transition:'background 0.25s'}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&display=swap');*{box-sizing:border-box;}`}</style>

      <div style={{width:'100%',maxWidth:380,display:'flex',flexDirection:'column',gap:24}}>
        {/* Logo */}
        <div style={{textAlign:'center'}}>
          <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'3rem',color:T.accent,letterSpacing:'0.06em',lineHeight:1}}>Ralscan</div>
          <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,marginTop:4,letterSpacing:'0.1em'}}>KLEUR IDENTIFICATIE TOOL</div>
        </div>

        {/* Session kicked message */}
        {sessionKicked && (
          <div style={{background:T.proGoldBg,border:`1px solid ${T.proGold}44`,borderRadius:8,padding:'14px 16px',display:'flex',gap:12,alignItems:'flex-start'}}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.proGold} strokeWidth="2" style={{flexShrink:0,marginTop:2}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            <div>
              <div style={{...mono,fontSize:'0.72rem',fontWeight:500,color:T.proGold,marginBottom:5}}>Sessie beëindigd</div>
              <div style={{...mono,fontSize:'0.67rem',color:T.textMuted,lineHeight:1.6}}>Er werd ingelogd op dit account via een ander apparaat, waardoor jouw sessie automatisch is beëindigd.</div>
              <div style={{...mono,fontSize:'0.67rem',color:T.textMuted,lineHeight:1.6,marginTop:5}}>Log opnieuw in om verder te gaan. Als jij dit niet was, raden we aan het wachtwoord van je e-mailaccount te wijzigen — iemand anders heeft mogelijk toegang tot jouw inbox.</div>
            </div>
          </div>
        )}

        {/* Form */}
        <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:12,padding:'24px',display:'flex',flexDirection:'column',gap:16}}>
          {authStep==='email' && (<>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.5rem',color:T.accent,letterSpacing:'0.06em',marginBottom:4}}>Inloggen of registreren</div>
              <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,lineHeight:1.5}}>Vul je e-mailadres in. We sturen een verificatiecode.</div>
            </div>
            <input
              style={inputStyle}
              type="email" placeholder="jouw@email.be"
              value={authEmail} onChange={e=>{setAuthEmail(e.target.value);setAuthError('');}}
              onKeyDown={e=>e.key==='Enter'&&sendCode()}
            />
            {authError && <div style={{...mono,fontSize:'0.68rem',color:T.red}}>{authError}</div>}
            <button style={{...primaryBtn,opacity:authLoading?0.6:1}} onClick={sendCode} disabled={authLoading}>
              {authLoading ? 'Versturen…' : 'Verstuur verificatiecode'}
            </button>
          </>)}

          {authStep==='code' && (<>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.5rem',color:T.accent,letterSpacing:'0.06em',marginBottom:4}}>Verificatiecode</div>
              <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,lineHeight:1.5}}>We hebben een 6-cijferige code gestuurd naar <strong style={{color:T.text}}>{authEmail}</strong>. Vul hem hieronder in.</div>
            </div>
            <input
              style={{...inputStyle,letterSpacing:'0.3em',fontSize:'1.4rem',textAlign:'center'}}
              type="text" inputMode="numeric" maxLength={6} placeholder="000000"
              value={authCode} onChange={e=>{setAuthCode(e.target.value.replace(/\D/g,''));setAuthError('');}}
              onKeyDown={e=>e.key==='Enter'&&verifyCode()}
              autoFocus
            />
            {authError && <div style={{...mono,fontSize:'0.68rem',color:T.red}}>{authError}</div>}
            <button style={{...primaryBtn,opacity:authLoading?0.6:1}} onClick={verifyCode} disabled={authLoading}>{authLoading?"Controleren...":"Bevestigen"}</button>
            <button style={{background:'transparent',border:'none',color:T.textMuted,...mono,fontSize:'0.72rem',cursor:'pointer',padding:0}} onClick={()=>{setAuthStep('email');setAuthCode('');setAuthError('');}}>
              ← Andere e-mail gebruiken
            </button>
          </>)}
        </div>

        <div style={{...mono,fontSize:'0.6rem',color:T.textFaint,textAlign:'center',lineHeight:1.6}}>
          Door in te loggen ga je akkoord met onze voorwaarden. We sturen je geen spam.
        </div>
      </div>
    </div>
  );

  // ==============================================================================
  // UPGRADE PAGE
  // ==============================================================================
  if(showUpgrade) return (
    <div style={{background:T.bg,minHeight:'100vh',color:T.text,fontFamily:'system-ui,sans-serif',display:'flex',flexDirection:'column',alignItems:'center',padding:'0 0 48px',transition:'background 0.25s'}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&display=swap');*{box-sizing:border-box;}`}</style>

      {/* Header */}
      <div style={{width:'100%',padding:'16px 20px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',gap:12}}>
        <button onClick={()=>setShowUpgrade(false)} style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:4,display:'flex',alignItems:'center',gap:6,...mono,fontSize:'0.78rem'}}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
          Terug
        </button>
        <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.4rem',color:T.accent,letterSpacing:'0.06em'}}>Upgrade naar Pro</span>
      </div>

      <div style={{width:'100%',maxWidth:460,padding:'24px 20px',display:'flex',flexDirection:'column',gap:16}}>

        {/* Hero */}
        <div style={{textAlign:'center',padding:'8px 0 4px'}}>
          <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,letterSpacing:'0.12em',marginBottom:8}}>KIES JE PLAN</div>
          <div style={{...mono,fontSize:'0.78rem',color:T.textMuted,lineHeight:1.6}}>
            Gratis scannen voor iedereen. Upgrade naar Pro voor kalibratie, projecten en volledige kleurdetails.
          </div>
        </div>

        {/* Plans grid — naast elkaar op brede schermen */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,320px),1fr))',gap:16,alignItems:'start'}}>
        {/* Free tier */}
        <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:12,padding:'20px',display:'flex',flexDirection:'column',gap:14}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.6rem',color:T.text,letterSpacing:'0.06em',lineHeight:1}}>Gratis</div>
              <div style={{...mono,fontSize:'0.7rem',color:T.textMuted,marginTop:2}}>Altijd beschikbaar</div>
            </div>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'2rem',color:T.textMuted,letterSpacing:'0.04em'}}>€0</div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {[
              ['✓','Foto scannen en RAL-kleur identificeren'],
              ['✓','1 beste RAL-match per scan'],
              ['✓','RAL-code, naam en HEX zichtbaar'],
              ['✓','Laatste 5 scans in geschiedenis'],
              ['✗','Top 3 matches + confidence score'],
              ['✗','Kalibratie (12-patch Lab-matrix)'],
              ['✗','Poedercoatcodes aluminium'],
              ['✗','Projecten aanmaken en scans groeperen'],
            ].map(([icon,text],i)=>(
              <div key={i} style={{display:'flex',gap:10,alignItems:'center'}}>
                <span style={{...mono,fontSize:'0.8rem',color:icon==='✓'?T.green:T.textFaint,width:14,flexShrink:0}}>{icon}</span>
                <span style={{...mono,fontSize:'0.72rem',color:icon==='✓'?T.text:T.textMuted}}>{text}</span>
              </div>
            ))}
          </div>
          <div style={{...mono,fontSize:'0.7rem',color:T.textMuted,background:T.surface,borderRadius:6,padding:'8px 10px',textAlign:'center'}}>
            Huidig plan{!isPro?' — je bent hier al':''}
          </div>
        </div>

        {/* Pro tier */}
        <div style={{background:dark?'#1a1508':'#fffbea',border:`2px solid ${T.proGold}`,borderRadius:12,padding:'20px',display:'flex',flexDirection:'column',gap:14}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
            <div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.6rem',color:T.proGold,letterSpacing:'0.06em',lineHeight:1}}>Pro</div>
              <div style={{...mono,fontSize:'0.7rem',color:T.textMuted,marginTop:2}}>Maandelijks opzegbaar</div>
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'2rem',color:T.proGold,letterSpacing:'0.04em',lineHeight:1}}>€9,99</div>
              <div style={{...mono,fontSize:'0.62rem',color:T.textMuted}}>/maand</div>
              <div style={{...mono,fontSize:'0.6rem',color:T.green,marginTop:2}}>of €99,99/jaar</div>
            </div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {[
              ['✓','Alles van Gratis'],
              ['✓','Top 3 RAL-matches + confidence score'],
              ['✓','Kalibratie met 12-patch Lab-matrix'],
              ['✓','Poedercoatcodes aluminium (Interpon, Tiger, Pulverit)'],
              ['✓','Onbeperkte scangeschiedenis'],
              ['✓','Projecten aanmaken en scans groeperen'],
              ['✓','Locatie-annotaties per scan'],
            ].map(([icon,text],i)=>(
              <div key={i} style={{display:'flex',gap:10,alignItems:'center'}}>
                <span style={{...mono,fontSize:'0.8rem',color:T.green,width:14,flexShrink:0}}>{icon}</span>
                <span style={{...mono,fontSize:'0.72rem',color:T.text}}>{text}</span>
              </div>
            ))}
          </div>

          {/* Stripe CTA buttons */}
          <button
            onClick={()=>{
              window.open('https://buy.stripe.com/aFafZa0Ns55Kg473x0fbq01', '_blank');
            }}
            style={{background:T.proGold,color:'#111',border:'none',borderRadius:8,padding:'14px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.2rem',letterSpacing:'0.08em',cursor:'pointer',width:'100%'}}>
            Start Pro — €9,99/maand
          </button>
          <button
            onClick={()=>{
              window.open('https://buy.stripe.com/4gM8wI2VA0PucRVaZsfbq00', '_blank');
            }}
            style={{background:'transparent',border:`1px solid ${T.proGold}`,color:T.proGold,borderRadius:8,padding:'12px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.1rem',letterSpacing:'0.08em',cursor:'pointer',width:'100%'}}>
            Jaarplan — €99,99/jaar
          </button>
        </div>

        </div>
        <div style={{...mono,fontSize:'0.62rem',color:T.textFaint,textAlign:'center',lineHeight:1.8}}>
          Veilige betaling via Stripe · btw inbegrepen · direct opzegbaar
        </div>

        {/* Abonnement beheren — alleen voor Pro users */}
        {isPro && (
          <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:10,padding:'14px 16px',display:'flex',flexDirection:'column',gap:10}}>
            <div>
              <div style={{...mono,fontSize:'0.72rem',fontWeight:500,color:T.text,marginBottom:3}}>Abonnement beheren</div>
              <div style={{...mono,fontSize:'0.65rem',color:T.textMuted,lineHeight:1.6}}>
                Bekijk je facturen, pas je betaalmethode aan of zeg je abonnement op via de beveiligde Stripe klantenportal.
                {user?.subscriptionStatus !== 'cancelled' && (
                  <span> Na opzegging behoudt je toegang tot het einde van de betaalde periode.</span>
                )}
              </div>
            </div>
            <button className="tap"
              onClick={()=>window.open('https://billing.stripe.com/p/login/4gM8wI2VA0PucRVaZsfbq00', '_blank')}
              style={{background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:7,padding:'11px 14px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1rem',letterSpacing:'0.07em',cursor:'pointer',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              Beheer abonnement via Stripe
            </button>
            <div style={{...mono,fontSize:'0.58rem',color:T.textFaint,textAlign:'center'}}>
              Je wordt doorgestuurd naar de beveiligde Stripe klantenportal · log in met {user?.email}
            </div>
          </div>
        )}
        {isCancelled && cancelEndDate && (
          <div style={{background:dark?'#2a0a0a':'#fff5f5',border:'1px solid #e5393544',borderRadius:10,padding:'14px 16px',textAlign:'center'}}>
            <div style={{...mono,fontSize:'0.7rem',color:'#c0392b',lineHeight:1.6}}>
              Abonnement opgezegd. Toegang tot en met <strong>{cancelEndDate}</strong>.
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // ==============================================================================
  // SETTINGS PAGE
  // ==============================================================================
  if(showSettings) return (
    <div style={{background:T.bg,minHeight:'100vh',color:T.text,fontFamily:'system-ui,sans-serif',display:'flex',flexDirection:'column',alignItems:'center',padding:'0 0 48px',transition:'background 0.25s'}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&display=swap');*{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}.tap:active{opacity:0.6;}`}</style>

      {/* Header */}
      <div style={{width:'100%',padding:'12px 16px',borderBottom:`1px solid ${T.border}`,display:'flex',alignItems:'center',gap:12,background:T.bg}}>
        <button className="tap" onClick={()=>setShowSettings(false)}
          style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:4,display:'flex',alignItems:'center',gap:6,...mono,fontSize:'0.78rem'}}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
          Terug
        </button>
        <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.3rem',color:T.accent,letterSpacing:'0.06em',lineHeight:1}}>Account</div>
      </div>

      <div style={{width:'100%',maxWidth:500,padding:'20px 16px',display:'flex',flexDirection:'column',gap:20}}>

        {/* Account info */}
        <div>
          <div style={{...mono,fontSize:'0.6rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textMuted,marginBottom:10}}>Accountgegevens</div>
          <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:12,padding:'16px'}}>
            <div style={{display:'flex',flexDirection:'column',gap:12}}>
              <div>
                <div style={{...mono,fontSize:'0.6rem',color:T.textFaint,letterSpacing:'0.1em',textTransform:'uppercase',marginBottom:3}}>E-mailadres</div>
                <div style={{...mono,fontSize:'0.82rem',color:T.text}}>{user?.email}</div>
              </div>
              <div style={{borderTop:`1px solid ${T.border}`,paddingTop:12}}>
                <div style={{...mono,fontSize:'0.6rem',color:T.textFaint,letterSpacing:'0.1em',textTransform:'uppercase',marginBottom:6}}>Abonnement</div>
                <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                  <span style={{...mono,fontSize:'0.72rem',background:isPro?T.proGoldBg:T.surface,color:isPro?T.proGold:T.textMuted,padding:'3px 8px',borderRadius:20,border:`1px solid ${isPro?T.proGold+'44':T.border}`}}>
                    {isPro?'PRO':'GRATIS'}
                  </span>
                  {isPro && !isCancelled && (
                    <span style={{...mono,fontSize:'0.68rem',color:T.green}}>● actief</span>
                  )}
                  {isCancelled && cancelEndDate && (
                    <span style={{...mono,fontSize:'0.65rem',color:'#c0392b'}}>opgezegd · toegang tot {cancelEndDate}</span>
                  )}
                  {!isPro && (
                    <span style={{...mono,fontSize:'0.68rem',color:T.textMuted}}>gratis plan</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pro: Stripe portal */}
        {isPro && (
          <div>
            <div style={{...mono,fontSize:'0.6rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textMuted,marginBottom:10}}>Abonnement beheren</div>
            <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:12,padding:'16px',display:'flex',flexDirection:'column',gap:10}}>
              <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,lineHeight:1.6}}>
                Bekijk je facturen, pas je betaalmethode aan of zeg je abonnement op via de beveiligde Stripe klantenportal.
                {!isCancelled && <span> Na opzegging behoud je toegang tot het einde van de betaalde periode.</span>}
              </div>
              <button className="tap"
                onClick={()=>window.open('https://billing.stripe.com/p/login/4gM8wI2VA0PucRVaZsfbq00','_blank')}
                style={{background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:8,padding:'12px 14px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1rem',letterSpacing:'0.07em',cursor:'pointer',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                Beheer via Stripe
              </button>
              <div style={{...mono,fontSize:'0.6rem',color:T.textFaint,textAlign:'center'}}>
                facturen · betaalmethode · opzeggen · log in met {user?.email}
              </div>
            </div>
          </div>
        )}

        {/* Free: upgrade CTA */}
        {!isPro && (
          <div>
            <div style={{...mono,fontSize:'0.6rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textMuted,marginBottom:10}}>Upgraden naar Pro</div>
            <div style={{background:dark?'#1a1508':'#fffbea',border:`1px solid ${T.proGold}44`,borderRadius:12,padding:'16px',display:'flex',flexDirection:'column',gap:10}}>
              <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,lineHeight:1.6}}>
                Krijg toegang tot kalibratie, top 3 matches, poedercoatcodes en onbeperkte geschiedenis.
              </div>
              <button className="tap"
                onClick={()=>{setShowSettings(false);setShowUpgrade(true);}}
                style={{background:T.proGold,color:'#111',border:'none',borderRadius:8,padding:'12px 14px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1rem',letterSpacing:'0.07em',cursor:'pointer',width:'100%'}}>
                Bekijk Pro-plannen
              </button>
            </div>
          </div>
        )}

        {/* Uitloggen */}
        <div>
          <div style={{...mono,fontSize:'0.6rem',letterSpacing:'0.14em',textTransform:'uppercase',color:T.textMuted,marginBottom:10}}>Sessie</div>
          <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:12,padding:'16px'}}>
            <button className="tap"
              onClick={async ()=>{
                setShowSettings(false);
                await signOut();
              }}
              disabled={signOutLoading}
              style={{background:'transparent',border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:8,padding:'11px 14px',...mono,fontSize:'0.75rem',cursor:signOutLoading?'default':'pointer',width:'100%',opacity:signOutLoading?0.5:1,display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              {signOutLoading ? 'Uitloggen…' : 'Uitloggen'}
            </button>
          </div>
        </div>

        {/* App versie */}
        <div style={{...mono,fontSize:'0.6rem',color:T.textFaint,textAlign:'center'}}>{VERSION}</div>

      </div>
    </div>
  );

  // ==============================================================================
  // MAIN APP
  // ==============================================================================
  return (
    <div style={{background:T.bg,minHeight:'100vh',color:T.text,fontFamily:'system-ui,sans-serif',display:'flex',flexDirection:'column',alignItems:'center',paddingBottom:56,transition:'background 0.25s'}}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}
        .tap:active{opacity:0.6;}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.35}}
        .pulse{animation:pulse 1.4s ease-in-out infinite;}
        input:focus{outline:none;border-color:#e8d5b0 !important;}
      `}</style>
      <canvas ref={canvasRef} style={{display:'none'}}/>

      {/* Session kicked by poll banner — verschijnt wanneer andere sessie inlogt */}
      {sessionKickedByPoll && (
        <div style={{width:'100%',background:dark?'#2a1a00':'#fff5e0',borderBottom:`1px solid ${T.amber}44`,padding:'11px 16px',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',boxSizing:'border-box',zIndex:200}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.amber} strokeWidth="2.5" style={{flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span style={{...mono,fontSize:'0.68rem',color:T.amber,flex:1,lineHeight:1.5}}>
            <strong>Andere sessie gedetecteerd.</strong> Je account is ingelogd op een ander apparaat. Je wordt automatisch uitgelogd...
          </span>
        </div>
      )}

      {/* Storage warning banner */}
      {storageWarning && (
        <div style={{width:'100%',background:dark?'#2a1500':'#fff5e6',borderBottom:`1px solid ${T.amber}44`,padding:'10px 16px',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',boxSizing:'border-box',zIndex:100}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.amber} strokeWidth="2.5" style={{flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span style={{...mono,fontSize:'0.65rem',color:T.amber,flex:1,lineHeight:1.5}}>
            <strong>Opslag bijna vol.</strong> Verwijder oude projecten of foto's om ruimte vrij te maken. Nieuwe foto's worden mogelijk niet meer opgeslagen.
          </span>

        </div>
      )}

      {/* Payment success banner — verschijnt na redirect van Stripe */}
      {paymentSuccess && (
        <div style={{width:'100%',background:dark?'#0a2a0a':'#e8f5e8',borderBottom:`1px solid ${T.greenBorder}`,padding:'11px 16px',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',boxSizing:'border-box'}}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={T.green} strokeWidth="2.5" style={{flexShrink:0}}><polyline points="20 6 9 17 4 12"/></svg>
          <span style={{...mono,fontSize:'0.68rem',color:T.green,flex:1,lineHeight:1.5}}>
            <strong>Betaling geslaagd!</strong> Je Pro-abonnement is actief. Log even opnieuw in om je account bij te werken.
          </span>
          <button className="tap" onClick={async()=>{setPaymentSuccess(false);await signOut();}}
            style={{background:T.green,color:'#fff',border:'none',borderRadius:6,padding:'5px 11px',...mono,fontSize:'0.62rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
            Opnieuw inloggen
          </button>
          <button className="tap" onClick={()=>setPaymentSuccess(false)}
            style={{background:'transparent',border:'none',color:T.green,fontSize:'1rem',cursor:'pointer',padding:'0 2px',lineHeight:1,flexShrink:0}}>✕</button>
        </div>
      )}

      {/* Cancellation banner */}
      {isCancelled && cancelEndDate && (
        <div style={{width:'100%',background:dark?'#2a0a0a':'#fde8e8',borderBottom:`1px solid #e5393544`,padding:'9px 16px',display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',boxSizing:'border-box'}}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c0392b" strokeWidth="2" style={{flexShrink:0}}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span style={{...mono,fontSize:'0.67rem',color:'#c0392b',flex:1,lineHeight:1.5}}>
            Je Pro-abonnement is opgezegd. Je behoudt toegang tot <strong>{cancelEndDate}</strong>. Daarna wordt je account teruggezet naar Gratis.
          </span>
          <button className="tap" onClick={()=>setShowUpgrade(true)}
            style={{background:'#c0392b',color:'#fff',border:'none',borderRadius:6,padding:'5px 11px',...mono,fontSize:'0.62rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
            Heractiveer
          </button>
        </div>
      )}





      {/* Toast for demo code */}

      {/* Altijd aanwezige hidden inputs voor foto selectie */}
      <input ref={galleryInputRef} type="file" accept="image/*" multiple
        onChange={e=>handleMultipleFiles(e.target.files)}
        style={{display:'none'}}/>

      {/* -- GLOBALE MODALS — nieuw project + hernoem -- */}
      {renamingProj && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',zIndex:300,display:'flex',alignItems:'flex-end',justifyContent:'center'}}
          onClick={e=>{if(e.target===e.currentTarget){setRenamingProj(null);setRenameName('');}}}>
          <div style={{width:'100%',maxWidth:500,background:T.surface,borderRadius:'16px 16px 0 0',padding:'20px 18px 32px'}}>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.3rem',color:T.accent,letterSpacing:'0.06em',marginBottom:12}}>Project hernoemen</div>
            <input
              placeholder="Projectnaam"
              value={renameName}
              onChange={e=>setRenameName(e.target.value)}
              onKeyDown={e=>{
                if(e.key==='Enter' && renameName.trim()){
                  renameProject(renamingProj.id, renameName.trim());
                  setRenamingProj(null); setRenameName('');
                } else if(e.key==='Escape'){
                  setRenamingProj(null); setRenameName('');
                }
              }}
              style={{width:'100%',background:T.inputBg,border:`1px solid ${T.inputBorder}`,borderRadius:8,color:T.text,...mono,fontSize:'1rem',padding:'12px',outline:'none',boxSizing:'border-box',marginBottom:10}}
              autoFocus
            />
            <div style={{display:'flex',gap:8}}>
              <button className="tap" onClick={()=>{
                if(!renameName.trim()) return;
                renameProject(renamingProj.id, renameName.trim());
                setRenamingProj(null); setRenameName('');
              }} style={{flex:1,background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:8,padding:'12px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.1rem',letterSpacing:'0.06em',cursor:'pointer'}}>
                Opslaan
              </button>
              <button className="tap" onClick={()=>{setRenamingProj(null);setRenameName('');}}
                style={{background:T.surface,border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:8,padding:'12px 14px',...mono,fontSize:'0.75rem',cursor:'pointer'}}>
                Annuleer
              </button>
            </div>
          </div>
        </div>
      )}

      {showNewProj && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',zIndex:300,display:'flex',alignItems:'flex-end',justifyContent:'center'}}
          onClick={e=>{if(e.target===e.currentTarget){setShowNewProj(false);setNewProjName('');}}}>
          <div style={{width:'100%',maxWidth:500,background:T.surface,borderRadius:'16px 16px 0 0',padding:'20px 18px 32px'}}>
            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.3rem',color:T.accent,letterSpacing:'0.06em',marginBottom:12}}>Nieuw project</div>
            <input
              placeholder="bv. Familie De Smedt — voorgevel"
              value={newProjName}
              onChange={e=>setNewProjName(e.target.value)}
              onKeyDown={e=>{if(e.key==='Enter'&&newProjName.trim()){
                const p=newProject(newProjName.trim());
                setProjects(prev=>{const next=[p,...prev];saveProjects(next, user?.id);return next;});
                setActiveProject(p.id); setNewProjName(''); setShowNewProj(false);
              }}}
              style={{width:'100%',background:T.inputBg,border:`1px solid ${T.inputBorder}`,borderRadius:8,color:T.text,...mono,fontSize:'1rem',padding:'12px',outline:'none',boxSizing:'border-box',marginBottom:10}}
              autoFocus
            />
            <div style={{display:'flex',gap:8}}>
              <button className="tap" onClick={()=>{
                if(!newProjName.trim()) return;
                const p=newProject(newProjName.trim());
                setProjects(prev=>{const next=[p,...prev];saveProjects(next, user?.id);return next;});
                setActiveProject(p.id); setNewProjName(''); setShowNewProj(false);
              }} style={{flex:1,background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:8,padding:'12px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.1rem',letterSpacing:'0.06em',cursor:'pointer'}}>
                Aanmaken
              </button>
              <button className="tap" onClick={()=>{setShowNewProj(false);setNewProjName('');}}
                style={{background:T.surface,border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:8,padding:'12px 14px',...mono,fontSize:'0.75rem',cursor:'pointer'}}>
                Annuleer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* -- HEADER — sticky, floats above content on scroll -- */}
      <div style={{width:'100%',padding:'10px 14px 8px',borderBottom:`1px solid ${T.border}`,background:T.bg,transition:'background 0.25s',position:'sticky',top:0,zIndex:100}}>
        {/* Row 1: logo + badges + icon buttons */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:6,marginBottom:7}}>
          <div style={{display:'flex',alignItems:'center',gap:7,minWidth:0}}>
            <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.75rem',color:T.accent,letterSpacing:'0.06em',lineHeight:1,flexShrink:0}}>Ralscan</span>
            {/* Calibration badge — inline, no wrap */}
            {calibDone && (
              <span style={{...mono,fontSize:'0.5rem',background:T.greenBg,color:T.green,padding:'2px 6px',borderRadius:20,border:`1px solid ${T.greenBorder}`,whiteSpace:'nowrap',flexShrink:0}}>✓ gekalibreerd</span>
            )}
            {/* Plan badge */}
            <span style={{...mono,fontSize:'0.5rem',background:isPro?T.proGoldBg:T.surface,color:isPro?T.proGold:T.textMuted,padding:'2px 6px',borderRadius:20,border:`1px solid ${isPro?T.proGold+'44':T.border}`,whiteSpace:'nowrap',flexShrink:0}}>
              {isPro?'PRO':'GRATIS'}
            </span>
          </div>
          {/* Icon buttons */}
          <div style={{display:'flex',alignItems:'center',gap:6,flexShrink:0}}>
            <button className="tap" onClick={()=>setDark(d=>!d)} title={dark?'Licht':'Donker'}
              style={{background:T.toggleBg,border:`1px solid ${T.border}`,borderRadius:'50%',width:30,height:30,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}>
              {dark ? <IconSun color={T.textMuted}/> : <IconMoon color={T.textMuted}/>}
            </button>
            <button className="tap" onClick={()=>setShowSettings(true)} title="Instellingen"
              style={{background:T.toggleBg,border:`1px solid ${T.border}`,borderRadius:'50%',width:30,height:30,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:T.textMuted}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>
            </button>
            <button className="tap" onClick={signOut} title="Uitloggen" disabled={signOutLoading}
              style={{background:T.toggleBg,border:`1px solid ${T.border}`,borderRadius:'50%',width:30,height:30,cursor:signOutLoading?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',color:T.textMuted,opacity:signOutLoading?0.4:1}}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            </button>
          </div>
        </div>
        {/* Row 2: tabs — full width, no overflow */}
        <div style={{display:'flex',background:dark?'#151515':'#e0ddd8',borderRadius:6,padding:3,gap:2}}>
          {['scan','calib','log'].map(t=>(
            <button key={t} className="tap" onClick={()=>{setTab(t);setShowNewProj(false);setRenamingProj(null);}}
              style={{flex:1,background:tab===t?(dark?'#2a2a2a':'#fff'):'transparent',border:'none',color:tab===t?T.text:T.textMuted,...mono,fontSize:'0.55rem',letterSpacing:'0.05em',textTransform:'uppercase',padding:'7px 2px',borderRadius:4,cursor:'pointer',transition:'background 0.15s',boxShadow:tab===t&&!dark?'0 1px 3px rgba(0,0,0,0.1)':'none'}}>
              {t==='scan'?'Scan':t==='calib'?'Kalibratie':'Log'}
            </button>
          ))}
        </div>
      </div>

      <div style={{width:'100%',maxWidth:1100,padding:'14px 14px 0'}}>

        {/* ==== SCAN TAB ==== */}
        {tab==='scan' && (<>
        {imgData && !calibMode && !calibDone && (
          <div style={{...mono,fontSize:'0.72rem',color:dark?'#d4a84b':'#8a5a00',background:dark?'#1a1a10':'#fffbea',border:`1px solid ${dark?'#3a3018':'#e0d08a'}`,borderRadius:8,padding:'11px 14px',marginBottom:14,display:'flex',gap:9,alignItems:'center',lineHeight:1.5}}>
            <span style={{fontSize:'1rem',flexShrink:0}}>⚠️</span>
            <span><strong>Geen kalibratie actief.</strong> Resultaten zijn minder nauwkeurig — kalibreer voor de hoogste precisie.</span>
          </div>
        )}
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,440px),1fr))',gap:20,alignItems:'start'}}>
        {/* === LEFT COLUMN: foto + knoppen === */}
        <div>
          {!imgData && (
            <div style={{display:'flex',flexDirection:'column',gap:14}}>
              {/* Foto knoppen — naast elkaar */}
              <div style={{display:'flex',gap:10}}>
                <button className="tap" onClick={()=>cameraInputRef.current?.click()}
                  style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:9,background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:8,padding:'13px 8px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.05rem',letterSpacing:'0.07em',cursor:'pointer'}}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
                  Foto nemen
                </button>
                <button className="tap" onClick={()=>fileInputRef.current?.click()}
                  style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:9,background:T.btnSecondary,color:T.accent,border:`1px solid ${T.btnSecBorder}`,borderRadius:8,padding:'13px 8px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.05rem',letterSpacing:'0.07em',cursor:'pointer'}}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                  Bibliotheek
                </button>
              </div>
              <input ref={cameraInputRef} type="file" accept="image/*" capture="environment" onChange={e=>handleFile(e.target.files[0])} style={{display:'none'}}/>
              <input ref={fileInputRef}   type="file" accept="image/*" multiple              onChange={e=>handleMultipleFiles(e.target.files)} style={{display:'none'}}/>

              {/* Indicatief resultaat warning */}
              <div style={{background:dark?'#1a1a14':'#fffbea',border:`1px solid ${dark?'#2e2a18':'#e0d08a'}`,borderRadius:8,padding:'11px 13px',display:'flex',gap:9}}>
                <span style={{flexShrink:0}}>⚠️</span>
                <p style={{...mono,fontSize:'0.62rem',color:dark?'#9a8a5a':'#6a5a10',lineHeight:1.6,margin:0}}>
                  <strong style={{color:dark?'#c8b87a':'#8a6a00'}}>Indicatief resultaat.</strong> Vermijd reflecties, schaduwen en natte oppervlakken. Gebruik voor definitieve identificatie een fysieke RAL-kleurenwaaier.
                </p>
              </div>

              {/* Project sectie */}
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:4}}>
                <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.1rem',color:T.accent,letterSpacing:'0.06em'}}>Projecten</span>
                <button className="tap" onClick={()=>isPro?setShowNewProj(true):setShowUpgrade(true)}
                  style={{background:isPro?T.btnPrimary:T.surface,color:isPro?T.btnPrimaryText:T.textMuted,border:`1px solid ${isPro?'transparent':T.border}`,borderRadius:6,padding:'6px 11px',...mono,fontSize:'0.65rem',cursor:'pointer',display:'flex',alignItems:'center',gap:5}}>
                  {!isPro && <IconLock size={11} color={T.textFaint}/>}
                  + Nieuw project
                </button>
              </div>

              {/* Active project banner */}
              {activeProject && (()=>{
                const proj = projects.find(p=>p.id===activeProject);
                if(!proj) return null;
                return (
                  <div style={{background:dark?'#0f1f0f':'#e8f5e8',border:`1px solid ${T.greenBorder}`,borderRadius:8,padding:'9px 12px',display:'flex',alignItems:'center',gap:10}}>
                    <div style={{width:7,height:7,borderRadius:'50%',background:T.green,flexShrink:0}} className="pulse"/>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{...mono,fontSize:'0.55rem',color:T.green,letterSpacing:'0.1em',textTransform:'uppercase',marginBottom:1}}>Actief project</div>
                      <div style={{...mono,fontSize:'0.74rem',color:T.text,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{proj.name}</div>
                      <div style={{...mono,fontSize:'0.55rem',color:T.textMuted}}>{(proj.photos||[]).length} foto{(proj.photos||[]).length!==1?'s':''} · {projectScanCount(proj)} scan{projectScanCount(proj)!==1?'s':''}</div>
                    </div>
                    <button className="tap" onClick={()=>{setActiveProject(null);setActivePhotoId(null);}}
                      style={{background:'transparent',border:`1px solid ${T.greenBorder}`,color:T.green,borderRadius:6,padding:'4px 8px',...mono,fontSize:'0.58rem',cursor:'pointer',whiteSpace:'nowrap'}}>
                      Stop
                    </button>
                  </div>
                );
              })()}

              {/* Uitklapbare projectenlijst — zelfde stijl als log tab */}
              {projects.length === 0 ? (
                <div style={{textAlign:'center',padding:'18px 14px',color:T.textMuted,...mono,fontSize:'0.66rem',lineHeight:1.6,background:T.surface,borderRadius:8,border:`1px solid ${T.border}`}}>
                  Nog geen projecten.<br/>Maak een project aan om scans te groeperen.
                </div>
              ) : (
                <div style={{display:'flex',flexDirection:'column',gap:6}}>
                  {projects.map(proj => {
                    const isActive    = activeProject === proj.id;
                    const isCollapsed = collapsedProj[proj.id] !== false;
                    const toggle      = () => setCollapsedProj(p=>({...p,[proj.id]:!isCollapsed}));
                    const scanCnt     = projectScanCount(proj);
                    const photoCnt    = (proj.photos||[]).length;
                    return (
                      <div key={proj.id} style={{background:isActive?(dark?'#0f1f0f':'#e8f5e8'):T.cardBg,border:`1.5px solid ${isActive?T.green:T.cardBorder}`,borderRadius:10,overflow:'hidden',transition:'border-color 0.15s'}}>
                        {/* Header */}
                        <div style={{padding:'9px 11px',display:'flex',alignItems:'center',gap:7}}>
                          <button className="tap" onClick={toggle}
                            style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:'2px 3px',flexShrink:0,lineHeight:0}}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                              style={{transition:'transform 0.2s',transform:isCollapsed?'rotate(-90deg)':'rotate(0deg)',display:'block'}}>
                              <polyline points="6 9 12 15 18 9"/>
                            </svg>
                          </button>
                          <div style={{flex:1,minWidth:0,cursor:'pointer'}} onClick={toggle}>
                            <div style={{display:'flex',alignItems:'center',gap:5}}>
                              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'0.95rem',color:isActive?T.green:T.accent,letterSpacing:'0.04em',lineHeight:1.1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',minWidth:0}}>{proj.name}</div>
                              <button className="tap" onClick={(e)=>{e.stopPropagation();setRenamingProj(proj);setRenameName(proj.name);}}
                                title="Hernoem"
                                style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:'2px',display:'flex',alignItems:'center',flexShrink:0,lineHeight:0,opacity:0.6}}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                              </button>
                            </div>
                            <div style={{...mono,fontSize:'0.55rem',color:T.textMuted,marginTop:2}}>{proj.date} · {photoCnt} foto{photoCnt!==1?'s':''} · {scanCnt} scan{scanCnt!==1?'s':''}{isActive?' · actief':''}</div>
                          </div>
                          <div style={{display:'flex',gap:4,flexShrink:0}}>
                          {!isActive ? (
                            <button className="tap" onClick={()=>{setActiveProject(proj.id);setActivePhotoId(null);}}
                              style={{background:T.surface,border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:5,padding:'4px 9px',...mono,fontSize:'0.58rem',cursor:'pointer',whiteSpace:'nowrap'}}>
                              Activeer
                            </button>
                          ) : (
                            <button className="tap" onClick={()=>{setActiveProject(null);setActivePhotoId(null);}}
                              style={{background:dark?'#0f2a0f':'#e0f0e0',border:`1px solid ${T.green}44`,color:T.green,borderRadius:5,padding:'4px 8px',...mono,fontSize:'0.58rem',cursor:'pointer'}}>
                              Stop
                            </button>
                          )}
                          <button className="tap" onClick={()=>{
                            if(!window.confirm('Project "'+proj.name+'" verwijderen?')) return;
                            setProjects(prev=>{
                              const next=prev.filter(p=>p.id!==proj.id);
                              saveProjects(next, user?.id); // synchroon schrijven naar localStorage
                              return next;
                            });
                            if(activeProject===proj.id){setActiveProject(null);setActivePhotoId(null);}
                          }}
                            style={{background:'transparent',border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:5,padding:'4px 6px',...mono,fontSize:'0.65rem',cursor:'pointer'}}>
                            ✕
                          </button>
                          </div>
                        </div>
                        {/* Uitklapbare content — foto's en scans */}
                        {!isCollapsed && (
                          <div style={{borderTop:`1px solid ${T.divider}`}}>
                            {(proj.photos||[]).length === 0 ? (
                              <div style={{padding:'8px 12px',...mono,fontSize:'0.62rem',color:T.textFaint,fontStyle:'italic'}}>Geen foto's in dit project.</div>
                            ) : (
                              (proj.photos||[]).map((ph, phIdx) => {
                                const scans = ph.scans || [];
                                return (
                                  <div key={ph.id} style={{borderBottom:phIdx<(proj.photos.length-1)?`1px solid ${T.divider}`:'none'}}>
                                    {/* Foto header */}
                                    <div style={{padding:'7px 11px',display:'flex',alignItems:'center',gap:8,background:dark?'#0f0f0f':'#fafaf6'}}>
                                      <div style={{width:28,height:28,borderRadius:4,overflow:'hidden',background:T.surface,border:`1px solid ${T.border}`,flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        {ph.imgData
                                          ? <img src={ph.imgData} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                                          : <span style={{...mono,fontSize:'0.5rem',color:T.textFaint}}>—</span>
                                        }
                                      </div>
                                      <div style={{flex:1,minWidth:0}}>
                                        <div style={{...mono,fontSize:'0.6rem',color:T.text}}>Foto {phIdx+1}</div>
                                        <div style={{...mono,fontSize:'0.52rem',color:T.textMuted,marginTop:1}}>
                                          {scans.length} scan{scans.length!==1?'s':''}
                                        </div>
                                      </div>
                                      <button className="tap" onClick={()=>{
                                        setActiveProject(proj.id);
                                        switchToPhoto(ph.id);
                                      }} style={{background:T.surface,border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:5,padding:'3px 7px',...mono,fontSize:'0.52rem',cursor:'pointer',whiteSpace:'nowrap'}}>
                                        Open
                                      </button>
                                    </div>
                                    {/* Scans */}
                                    {scans.map((s,si) => (
                                      <div key={si} style={{padding:'5px 11px 5px 47px',display:'flex',alignItems:'center',gap:8,borderTop:`1px solid ${T.divider}`}}>
                                        <div style={{display:'flex',gap:3,flexShrink:0}}>
                                          <div style={{width:18,height:18,borderRadius:3,background:s.hex,border:`1px solid ${T.swatchBorder}`}}/>
                                          <div style={{width:18,height:18,borderRadius:3,background:s.ral.hex,border:`1px solid ${T.swatchBorder}`}}/>
                                        </div>
                                        <div style={{flex:1,minWidth:0}}>
                                          <div style={{...mono,fontSize:'0.62rem',color:T.text}}>{s.ral.code} <span style={{color:T.accent}}>{s.ral.name}</span></div>
                                          {s.note&&<div style={{...mono,fontSize:'0.55rem',color:T.textMuted,fontStyle:'italic',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>"{s.note}"</div>}
                                        </div>
                                        {s.calibrated && <span style={{...mono,fontSize:'0.5rem',background:T.greenBg,color:T.green,padding:'2px 6px',borderRadius:8,flexShrink:0,whiteSpace:'nowrap'}}>✓ gekalibreerd</span>}
                                      </div>
                                    ))}
                                  </div>
                                );
                              })
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {imgData && (<>
            {calibMode && (
              <div style={{background:dark?'#1a2e1a':'#e8f5e8',border:`1px solid ${T.greenBorder}`,borderRadius:8,padding:'10px 14px',marginBottom:10,display:'flex',gap:10,alignItems:'center'}}>
                <div className="pulse" style={{width:9,height:9,borderRadius:'50%',background:T.green,flexShrink:0}}/>
                <div style={{flex:1}}>
                  <div style={{...mono,fontSize:'0.68rem',color:T.green,fontWeight:500,marginBottom:2}}>Kalibratie stap {calibStep+1}/{CALIB_PATCHES.length} — {CALIB_PATCHES[calibStep].desc}</div>
                  <div style={{...mono,fontSize:'0.7rem',color:T.textMuted}}>Tik op het <strong style={{color:T.text}}>{CALIB_PATCHES[calibStep].label}</strong> vlak — zo vlak mogelijk, geen schaduw, zelfde belichting als je meetoppervlak</div>
                  <div style={{display:'flex',gap:4,marginTop:6}}>
                    {CALIB_PATCHES.map((p,i)=>(
                      <div key={p.id} style={{flex:1,height:5,borderRadius:3,background:i<calibStep?T.green:i===calibStep?(dark?'#3a5a3a':'#aadaaa'):T.divider,transition:'background 0.2s'}}/>
                    ))}
                  </div>
                </div>
                <button className="tap" onClick={()=>{setCalibMode(false);setCalibStep(0);setCalibSamples([]);}} style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:4}}>✕</button>
              </div>
            )}
            {/* Image */}
            <div style={{position:'relative',borderRadius:8,overflow:'hidden',border:`1px solid ${calibMode?T.green+'66':T.border}`,marginBottom:10,touchAction:'none',cursor:'crosshair',userSelect:'none',WebkitUserSelect:'none'}}
              onClick={handleClick}
              onTouchStart={(e)=>{
                if(e.touches.length===2){
                  // Pinch start - suppress any single-finger crosshair
                  isPinchingRef.current = true;
                  setLiveCross(null);
                  e.preventDefault();
                  const dx=e.touches[0].clientX-e.touches[1].clientX;
                  const dy=e.touches[0].clientY-e.touches[1].clientY;
                  pinchStartDist.current=Math.sqrt(dx*dx+dy*dy);
                  pinchStartScale.current=pinchScale;
                  const rect=e.currentTarget.getBoundingClientRect();
                  const mx=((e.touches[0].clientX+e.touches[1].clientX)/2-rect.left)/rect.width*100;
                  const my=((e.touches[0].clientY+e.touches[1].clientY)/2-rect.top)/rect.height*100;
                  setPinchOrigin({x:Math.max(0,Math.min(100,mx)),y:Math.max(0,Math.min(100,my))});
                } else {
                  handleTouchStart(e);
                }
              }}
              onTouchMove={(e)=>{
                if(e.touches.length===2){
                  e.preventDefault();
                  const dx=e.touches[0].clientX-e.touches[1].clientX;
                  const dy=e.touches[0].clientY-e.touches[1].clientY;
                  const dist=Math.sqrt(dx*dx+dy*dy);
                  if(pinchStartDist.current>0){
                    const newScale=Math.max(1,Math.min(5, pinchStartScale.current*(dist/pinchStartDist.current)));
                    setPinchScale(newScale);
                  }
                } else {
                  handleTouchMove(e);
                }
              }}
              onTouchEnd={(e)=>{
                // Pinch eindigend: reset dist, blokkeer meting via isPinchingRef
                if(pinchStartDist.current > 0 || isPinchingRef.current) {
                  if(e.touches.length < 2) {
                    pinchStartDist.current = 0;
                    // Houd isPinchingRef nog 120ms vast — het naijlende touchend
                    // van de laatste vinger mag geen meting triggeren
                    setTimeout(() => { isPinchingRef.current = false; }, 120);
                  }
                  setLiveCross(null);
                  return;
                }
                handleTouchEnd(e);
              }}>
              <img src={imgData} alt="" draggable={false}
                style={{width:'100%',display:'block',pointerEvents:'none',userSelect:'none',WebkitUserSelect:'none',
                  transformOrigin:`${pinchOrigin.x}% ${pinchOrigin.y}%`,
                  transform:`scale(${pinchScale})`,
                  transition: pinchStartDist.current ? 'none' : 'transform 0.15s'
                }}
              />
              {(liveCross||(!calibMode&&crosshair)) && (() => {
                const pos = liveCross||crosshair;
                const isLive = !!liveCross;
                return (
                  <div style={{position:'absolute',inset:0,pointerEvents:'none'}}>
                    <div style={{position:'absolute',top:`${pos.ry*100}%`,left:0,right:0,height:1,background:T.crosshair}}/>
                    <div style={{position:'absolute',left:`${pos.rx*100}%`,top:0,bottom:0,width:1,background:T.crosshair}}/>
                    <div style={{position:'absolute',top:`${pos.ry*100}%`,left:`${pos.rx*100}%`,transform:'translate(-50%,-50%)',width:isLive?28:22,height:isLive?28:22,borderRadius:'50%',border:`${isLive?3:2.5}px solid white`,background:scannedColor&&!isLive?scannedColor:'transparent',boxShadow:'0 0 0 1.5px rgba(0,0,0,0.5)'}}/>
                    {isLive && (
                      <div style={{position:'absolute',top:`${Math.max(0.08,pos.ry-0.12)*100}%`,left:`${Math.max(0.05,Math.min(0.75,pos.rx))*100}%`,transform:'translateY(-100%)',background:'rgba(0,0,0,0.75)',color:'white',...mono,fontSize:'0.65rem',padding:'4px 8px',borderRadius:6,whiteSpace:'nowrap'}}>
                        Laat los om te meten
                      </div>
                    )}
                  </div>
                );
              })()}
              {!calibMode && !crosshair && !liveCross && (
                <div style={{position:'absolute',bottom:10,left:'50%',transform:'translateX(-50%)',background:T.hintBg,color:'#fff',...mono,fontSize:'0.68rem',padding:'5px 13px',borderRadius:20,whiteSpace:'nowrap',pointerEvents:'none'}}>
                  Tik op de kleur die je wilt meten
                </div>
              )}
            </div>

            {/* v0.36: Thumbnailbalk — alleen tonen als er een actief project is met foto's */}
            {activeProject && (()=>{
              const proj = projects.find(p => p.id === activeProject);
              if(!proj) return null;
              const photos = proj.photos || [];
              if(photos.length === 0) return null;
              return (
                <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:10,padding:'6px 2px',overflowX:'auto',scrollbarWidth:'thin'}}>
                  <span style={{...mono,fontSize:'0.55rem',color:T.textMuted,letterSpacing:'0.1em',textTransform:'uppercase',flexShrink:0,paddingRight:2}}>foto's</span>
                  {photos.map((ph,idx) => {
                    const isActive = activePhotoId === ph.id;
                    return (
                      <div key={ph.id} style={{position:'relative',flexShrink:0}}>
                        <button className="tap" onClick={()=>switchToPhoto(ph.id)}
                          style={{width:42,height:42,borderRadius:6,border:`2px solid ${isActive?T.accent:T.border}`,background:T.cardBg,padding:0,cursor:'pointer',overflow:'hidden',display:'block',position:'relative'}}>
                          {ph.imgData
                            ? <img src={ph.imgData} alt="" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
                            : <div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',color:T.textFaint,fontSize:'0.55rem'}}>—</div>
                          }
                          <span style={{position:'absolute',bottom:1,right:2,fontFamily:"'DM Mono',monospace",fontSize:'0.5rem',color:'#fff',textShadow:'0 1px 2px rgba(0,0,0,0.7)',lineHeight:1}}>{idx+1}</span>
                          {ph.matrix && (
                            <span title="gekalibreerd" style={{position:'absolute',top:1,left:2,width:6,height:6,borderRadius:'50%',background:T.green,boxShadow:'0 0 0 1px rgba(0,0,0,0.4)'}}/>
                          )}
                        </button>
                        <button className="tap" onClick={(e)=>{e.stopPropagation();if(window.confirm('Foto verwijderen?')){removePhoto(ph.id);}}}
                          title="Verwijder foto"
                          style={{position:'absolute',top:-5,right:-5,width:16,height:16,borderRadius:'50%',background:T.cardBg,border:`1px solid ${T.border}`,color:T.textMuted,fontSize:'0.6rem',cursor:'pointer',padding:0,lineHeight:'13px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                          ×
                        </button>
                      </div>
                    );
                  })}
                  {/* + knop om extra foto's toe te voegen */}
                  <button className="tap" onClick={()=>galleryInputRef.current?.click()}
                    title="Voeg foto's toe"
                    style={{width:42,height:42,borderRadius:6,border:`1.5px dashed ${T.border}`,background:'transparent',color:T.textMuted,cursor:'pointer',padding:0,flexShrink:0,fontSize:'1.1rem',lineHeight:1,display:'flex',alignItems:'center',justifyContent:'center'}}>
                    +
                  </button>
                </div>
              );
            })()}

            {/* Controls */}
            <div style={{display:'flex',gap:7,marginBottom:14,flexWrap:'wrap'}}>
              {[
{label:calibDone?'✓ Herkalibreer':'⊙ Kalibreer',active:calibDone,pro:true,action:()=>proGate(()=>{setCalibMode(true);setCalibStep(0);setCalibSamples([]);})},
                {label:'↩ Nieuwe sessie',active:false,action:()=>{setImgData(null);setTopResults([]);setScannedColor(null);setCrosshair(null);setPinchScale(1);setPowderOpen(false);setCalibMode(false);setMatrix(null);matrixRef.current=null;setCalibDone(false);setActivePhotoId(null);setScanNote('');}},
              ].map((btn,i)=>(
                <button key={i} className="tap" onClick={btn.action}
                  style={{flex:1,background:btn.active?(dark?'#222218':'#faf5e8'):(dark?'#151515':'#f0efe8'),border:`1px solid ${btn.active?T.accent:T.border}`,color:btn.active?T.accent:T.textMuted,borderRadius:6,padding:'8px',...mono,fontSize:'0.62rem',letterSpacing:'0.05em',textTransform:'uppercase',cursor:'pointer',minWidth:80,transition:'all 0.15s',display:'flex',alignItems:'center',justifyContent:'center',gap:5}}>
                  {btn.pro && !isPro && <IconLock size={11} color={T.textFaint}/>}
                  {btn.label}
                </button>
              ))}
            </div>
          </>)}
        </div>

        {/* === RIGHT COLUMN: resultaten === */}
        <div>
          {/* Results */}
          {topResults.length>0 && (<>
            {/* Top matches — show 1 for free, 3 for pro */}
            <div style={{display:'flex',gap:7,marginBottom:12}}>
              {topResults.slice(0,3).map((r,i)=>{
                const locked = !isPro && i>0;
                const d = dc(r.de2000);
                return (
                  <div key={i} style={{flex:1,position:'relative'}}>
                    <button className="tap"
                      onClick={()=>locked?setShowUpgrade(true):(()=>{setSelectedIdx(i);setPowderOpen(false);})()}
                      style={{width:'100%',background:selectedIdx===i&&!locked?T.surface:(dark?'#111':'#f8f8f5'),border:`1.5px solid ${selectedIdx===i&&!locked?T.accent:T.border}`,borderRadius:7,padding:'9px 5px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:4,transition:'border-color 0.15s',filter:locked?'blur(1px)':'none',opacity:locked?0.5:1}}>
                      <div style={{width:26,height:26,borderRadius:4,background:r.ral.hex,border:`1px solid ${T.swatchBorder}`}}/>
                      <span style={{...mono,fontSize:'0.6rem',color:selectedIdx===i&&!locked?T.text:T.textMuted}}>{r.ral.code.replace('RAL ','')}</span>
                      <span style={{...mono,fontSize:'0.56rem',color:d.fg}}>ΔE {r.de2000.toFixed(1)}</span>
                      <span style={{...mono,fontSize:'0.56rem',color:d.fg}}>{deToConfidence(r.de2000)}%</span>
                    </button>
                    {locked && (
                      <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}} onClick={()=>setShowUpgrade(true)}>
                        <div style={{background:T.surface,borderRadius:6,padding:'4px 8px',display:'flex',alignItems:'center',gap:4,border:`1px solid ${T.border}`}}>
                          <IconLock size={11} color={T.textMuted}/><span style={{...mono,fontSize:'0.58rem',color:T.textMuted}}>Pro</span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {sel && (
              <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:10,overflow:'hidden',marginBottom:12,transition:'background 0.25s'}}>
                <div style={{display:'flex',height:64}}>
                  <div style={{flex:1,background:scannedColor,display:'flex',alignItems:'flex-end',padding:'4px 8px'}}>
                    <span style={{...mono,fontSize:'0.55rem',color:'rgba(255,255,255,0.85)',textShadow:'0 1px 3px rgba(0,0,0,0.9)'}}>Gescand{matrix?' ✓':''}</span>
                  </div>
                  <div style={{flex:1,background:sel.ral.hex,display:'flex',alignItems:'flex-end',justifyContent:'flex-end',padding:'4px 8px'}}>
                    <span style={{...mono,fontSize:'0.55rem',color:'rgba(255,255,255,0.85)',textShadow:'0 1px 3px rgba(0,0,0,0.9)'}}>RAL match</span>
                  </div>
                </div>
                <div style={{padding:'13px 15px'}}>
                  <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,marginBottom:12}}>
                    <div>
                      <span style={lbl}>RAL Naam</span>
                      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.65rem',color:T.accent,letterSpacing:'0.04em',lineHeight:1}}>{sel.ral.name}</div>
                    </div>
                    <button className="tap" onClick={()=>copyCode(sel.ral.code)}
                      title="RAL-code kopiëren"
                      style={{background:copied===sel.ral.code?T.greenBg:'transparent',border:`1px solid ${copied===sel.ral.code?T.green:T.border}`,color:copied===sel.ral.code?T.green:T.textMuted,borderRadius:6,padding:'5px 9px',...mono,fontSize:'0.58rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0,marginTop:3,transition:'all 0.15s',display:'flex',alignItems:'center',gap:4}}>
                      {copied===sel.ral.code ? '✓' : (
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      )}
                      {copied===sel.ral.code?'Gekopieerd':'Kopieer'}
                    </button>
                  </div>
                  {/* English name */}
                  {sel.ral.nameEn && (
                    <div style={{...mono,fontSize:'0.65rem',color:T.accent,marginBottom:8,marginTop:-6,fontStyle:'italic',opacity:0.75}}>
                      {sel.ral.nameEn}
                    </div>
                  )}
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
                    <div><span style={lbl}>Hex gescand</span><span style={{...mono,fontSize:'0.85rem',color:T.text}}>{scannedColor}</span></div>
                    <div><span style={lbl}>Hex RAL</span><span style={{...mono,fontSize:'0.85rem',color:T.text}}>{sel.ral.hex}</span></div>
                    <div>
                      <span style={lbl}>ΔE2000</span>
                      {(()=>{const d=dc(sel.de2000);return(<span style={{display:'inline-block',padding:'2px 9px',borderRadius:20,background:d.bg,color:d.fg,...mono,fontSize:'0.68rem'}}>{sel.de2000.toFixed(2)} — {d.label}</span>);})()}
                    </div>
                    <div>
                      <span style={lbl}>Betrouwbaarheid</span>
                      {(()=>{const conf=deToConfidence(sel.de2000);const d=dc(sel.de2000);return(
                        <div style={{display:'flex',alignItems:'center',gap:6,marginTop:2}}>
                          <div style={{flex:1,height:6,background:dark?'#222':'#e0ddd8',borderRadius:3,overflow:'hidden'}}>
                            <div style={{width:`${conf}%`,height:'100%',background:d.fg,borderRadius:3,transition:'width 0.4s'}}/>
                          </div>
                          <span style={{...mono,fontSize:'0.7rem',color:d.fg,flexShrink:0}}>{conf}%</span>
                        </div>
                      );})()}
                    </div>
                  </div>
                  {/* RGB + CMYK detail row */}
                  {(sel.ral.rgb || sel.ral.cmyk) && (
                    <div style={{background:T.surface,borderRadius:7,padding:'9px 11px',marginBottom:12,display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
                      {sel.ral.rgb && (
                        <div>
                          <span style={lbl}>RGB</span>
                          <span style={{...mono,fontSize:'0.78rem',color:T.text}}>
                            {sel.ral.rgb[0]} / {sel.ral.rgb[1]} / {sel.ral.rgb[2]}
                          </span>
                        </div>
                      )}
                      {sel.ral.cmyk && (
                        <div>
                          <span style={lbl}>CMYK</span>
                          <span style={{...mono,fontSize:'0.78rem',color:T.text}}>
                            {sel.ral.cmyk[0]} / {sel.ral.cmyk[1]} / {sel.ral.cmyk[2]} / {sel.ral.cmyk[3]}
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Poedercoat — Pro only */}
                  <div style={{borderTop:`1px solid ${T.divider}`,paddingTop:11,position:'relative'}}>
                      <button className="tap"
                        onClick={()=>isPro?setPowderOpen(o=>!o):setShowUpgrade(true)}
                        style={{width:'100%',background:'transparent',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'space-between',padding:0,filter:!isPro?'opacity(0.5)':'none'}}>
                        <div style={{display:'flex',alignItems:'center',gap:7}}>
                          {!isPro && <IconLock size={11} color={T.textFaint}/>}
                          <div style={{width:7,height:7,borderRadius:2,background:T.accent}}/>
                          <span style={{...mono,fontSize:'0.64rem',letterSpacing:'0.1em',textTransform:'uppercase',color:T.textMuted}}>Poedercoat aluminium</span>
                          {isPro && powderCodes.length>0 && <span style={{...mono,fontSize:'0.57rem',color:T.textMuted}}>{powderCodes.length}×</span>}
                          {!isPro && <span style={{...mono,fontSize:'0.57rem',color:T.proGold,background:T.proGoldBg,padding:'1px 6px',borderRadius:10}}>PRO</span>}
                        </div>
                        {isPro && <span style={{color:T.textMuted,transform:powderOpen?'rotate(180deg)':'none',transition:'transform 0.2s',display:'inline-block'}}>▾</span>}
                      </button>
                      {isPro && powderOpen && powderCodes.length>0 && (
                        <div style={{marginTop:10,display:'flex',flexDirection:'column',gap:7}}>
                          <p style={{...mono,fontSize:'0.58rem',color:T.textMuted,lineHeight:1.5}}>⚠ Indicatief — verifieer bij leverancier.</p>
                          {powderCodes.map((p,i)=>{const mc=merkColors[p.merk]||{bg:T.surface,fg:T.textMuted,dot:'#888'};return(
                            <div key={i} style={{background:mc.bg,borderRadius:7,padding:'10px 12px',display:'flex',alignItems:'center',gap:11}}>
                              <div style={{width:9,height:9,borderRadius:'50%',background:mc.dot,flexShrink:0}}/>
                              <div style={{flex:1}}>
                                <div style={{...mono,fontSize:'0.62rem',color:mc.fg,fontWeight:500,marginBottom:1}}>{p.merk}</div>
                                <div style={{...mono,fontSize:'0.78rem',color:dark?'#ddd':'#111',letterSpacing:'0.05em'}}>{p.code}</div>
                                <div style={{...mono,fontSize:'0.58rem',color:T.textMuted,marginTop:1}}>{p.afwerking} · {p.klasse}</div>
                              </div>
                              <button className="tap" onClick={()=>copyCode(p.code)} style={{background:copied===p.code?T.greenBg:(dark?'rgba(255,255,255,0.04)':'rgba(0,0,0,0.04)'),border:`1px solid ${copied===p.code?T.green:(dark?'rgba(255,255,255,0.07)':'rgba(0,0,0,0.1)')}`,color:copied===p.code?T.green:T.textMuted,borderRadius:5,padding:'4px 8px',...mono,fontSize:'0.6rem',cursor:'pointer'}}>
                                {copied===p.code?'✓':'Kopieer'}
                              </button>
                            </div>
                          );})}
                        </div>
                      )}
                      {isPro && powderOpen && powderCodes.length===0 && (
                        <div style={{marginTop:8,padding:'10px',background:T.surface,borderRadius:7,textAlign:'center'}}>
                          <p style={{...mono,fontSize:'0.68rem',color:T.textMuted}}>Niet beschikbaar. Neem contact op met leverancier.</p>
                        </div>
                      )}
                  </div>

                  {/* v0.36: Annotatie + Opslaan in project — alleen tonen als er een actief project is */}
                  {activeProject && (
                    <div style={{borderTop:`1px solid ${T.divider}`,paddingTop:12,marginTop:12,display:'flex',flexDirection:'column',gap:9}}>
                      <input
                        type="text"
                        placeholder="bv. keukenraam, gevel noord, deur badkamer..."
                        value={scanNote}
                        onChange={e=>setScanNote(e.target.value)}
                        onKeyDown={e=>{ if(e.key==='Enter'){ e.preventDefault(); saveScanToProject(); } }}
                        style={{width:'100%',background:T.inputBg,border:`1px solid ${T.inputBorder}`,borderRadius:7,color:T.text,...mono,fontSize:'0.78rem',padding:'10px 12px',outline:'none',boxSizing:'border-box'}}
                      />
                      <button className="tap" onClick={saveScanToProject}
                        style={{width:'100%',background:T.btnPrimary,color:T.btnPrimaryText,border:'none',borderRadius:7,padding:'12px',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.05rem',letterSpacing:'0.07em',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                        Opslaan in project
                      </button>
                      {(()=>{
                        const proj = projects.find(p => p.id===activeProject);
                        return proj ? (
                          <div style={{...mono,fontSize:'0.6rem',color:T.textMuted,textAlign:'center'}}>
                            → opslaan in <span style={{color:T.green}}>{proj.name}</span>
                          </div>
                        ) : null;
                      })()}
                    </div>
                  )}
                  {/* Hint als er geen actief project is */}
                  {!activeProject && (
                    <div style={{borderTop:`1px solid ${T.divider}`,paddingTop:11,marginTop:12}}>
                      <div style={{...mono,fontSize:'0.62rem',color:T.textMuted,lineHeight:1.6,textAlign:'center'}}>
                        Activeer of maak een project om deze scan op te slaan.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>)}
        </div>
        </div>
        </>)}

        {/* ==== CALIBRATION TAB ==== */}
        {tab==='calib' && (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,400px),1fr))',gap:20,alignItems:'start'}}>
            {!isPro && (
              <div style={{background:T.proGoldBg,border:`1px solid ${T.proGold}44`,borderRadius:10,padding:'16px 18px',display:'flex',gap:14,alignItems:'center'}}>
                <IconLock size={20} color={T.proGold}/>
                <div style={{flex:1}}>
                  <div style={{...mono,fontSize:'0.75rem',color:T.proGold,fontWeight:500,marginBottom:3}}>Pro functie</div>
                  <div style={{...mono,fontSize:'0.68rem',color:T.textMuted,lineHeight:1.5}}>Kalibratie is beschikbaar vanaf het Pro-abonnement. Upgrade voor nauwkeurigere kleuridentificatie.</div>
                </div>
                <button onClick={()=>setShowUpgrade(true)} style={{background:T.proGold,color:'#111',border:'none',borderRadius:6,padding:'8px 12px',...mono,fontSize:'0.68rem',cursor:'pointer',whiteSpace:'nowrap'}}>Upgrade</button>
              </div>
            )}
            <div style={{background:T.cardBg,border:`1px solid ${T.cardBorder}`,borderRadius:10,padding:'16px',filter:!isPro?'blur(2px)':'none',pointerEvents:!isPro?'none':'auto',transition:'filter 0.3s'}}>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.3rem',color:T.accent,letterSpacing:'0.06em',marginBottom:8}}>Kalibreerkaart</div>
              <div style={{background:'#f5f5f5',borderRadius:8,padding:'14px 10px 10px'}}>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:8}}>
                  {CALIB_PATCHES.map(p=>(
                    <div key={p.id} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:5}}>
                      <div style={{width:'100%',height:0,paddingBottom:'100%',borderRadius:6,background:p.color,border:'1.5px solid rgba(0,0,0,0.12)',position:'relative'}}/>
                      <span style={{fontFamily:'monospace',fontSize:'0.58rem',color:'#444',textAlign:'center',lineHeight:1.2}}>{p.label}<br/>{p.desc}</span>
                    </div>
                  ))}
                </div>
                <div style={{borderTop:'1px solid #ddd',paddingTop:8,textAlign:'center'}}>
                  <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'0.72rem',color:'#888',letterSpacing:'0.12em'}}>RALSCAN KALIBREERKAART · {VERSION}</span>
                </div>
              </div>
              <p style={{...mono,fontSize:'0.62rem',color:T.textMuted,lineHeight:1.7,marginTop:10}}>
                <strong style={{color:T.text}}>Voor beste resultaten:</strong> Print op mat wit papier · niet lamineren (reflecties) · vlak houden · gebruik dezelfde belichting als het te meten oppervlak · houd de kaart vlak zonder schaduwen · tik op het midden van elk vlak
              </p>
              <div style={{background:dark?'#1a1a14':'#fffbea',border:`1px solid ${dark?'#2e2a18':'#e0d08a'}`,borderRadius:6,padding:'8px 10px',marginTop:6}}>
                <p style={{...mono,fontSize:'0.62rem',color:dark?'#9a8a5a':'#8a6a00',lineHeight:1.6,margin:0}}>
                  💡 Tip: de kalibratie corrigeert de witbalans van je camera. Kalibreer altijd bij dezelfde lichtomstandigheden als je meting. Binnenlicht (warm) vs buitenlicht (koud) geeft andere kalibratiematrices.
                </p>
              </div>
            </div>
            {/* Rechter kolom: status + uitleg */}
            <div style={{display:'flex',flexDirection:'column',gap:14}}>
            {isPro && (
              <div style={{background:T.cardBg,border:`1px solid ${calibDone?T.green+'44':T.cardBorder}`,borderRadius:10,padding:'16px'}}>
                <div style={{...mono,fontSize:'0.62rem',color:T.textMuted,letterSpacing:'0.12em',textTransform:'uppercase',marginBottom:10}}>Status huidige sessie</div>
                {!calibDone
                  ? <div style={{...mono,fontSize:'0.72rem',color:T.textMuted}}>Nog niet gekalibreerd. Laad een foto en klik op "⊙ Kalibreer".</div>
                  : (<div style={{display:'flex',flexDirection:'column',gap:10}}>
                      {(()=>{
                        const errs = CALIB_PATCHES.map((p,i)=>{
                          if(!calibSamples[i]) return 0;
                          const corrLab = applyLabMatrix(...calibSamples[i].measured, matrix);
                          return deltaE2000(corrLab, rgbToLab(...p.trueRgb));
                        }).filter(Boolean);
                        const avgErr = errs.length ? errs.reduce((a,v)=>a+v,0)/errs.length : 99;
                        const good = avgErr < 8;
                        return (
                          <div style={{display:'flex',flexDirection:'column',gap:6}}>
                            <div style={{display:'flex',alignItems:'center',gap:8}}>
                              <div style={{width:9,height:9,borderRadius:'50%',background:good?T.green:T.amber}}/>
                              <span style={{...mono,fontSize:'0.72rem',color:good?T.green:T.amber}}>
                                Actief — gem. ΔE {avgErr.toFixed(1)} {good?'✓':'⚠'}
                              </span>
                            </div>
                            {!good && (
                              <div style={{...mono,fontSize:'0.64rem',color:T.amber,lineHeight:1.5,background:T.amberBg,borderRadius:6,padding:'7px 10px'}}>
                                ⚠ Hoge foutmarge. Tips: gebruik de gedrukte kalibreerkaart bij dezelfde belichting als het te meten oppervlak. Vermijd schaduwen op de kaart.
                              </div>
                            )}
                          </div>
                        );
                      })()}
                      <div style={{display:'flex',gap:7,flexWrap:'wrap'}}>
                        {CALIB_PATCHES.map((p,i)=>{
                          if(!calibSamples[i]) return null;
                          const corrLab=applyLabMatrix(...calibSamples[i].measured,matrix);
                          const err=deltaE2000(corrLab,rgbToLab(...p.trueRgb));
                          return(
                            <div key={p.id} style={{background:T.surface,borderRadius:6,padding:'7px 10px',display:'flex',alignItems:'center',gap:7,border:`1px solid ${T.border}`}}>
                              <div style={{width:12,height:12,borderRadius:2,background:p.color,border:'1px solid rgba(0,0,0,0.15)'}}/>
                              <div>
                                <div style={{...mono,fontSize:'0.6rem',color:T.textMuted}}>{p.label}</div>
                                <div style={{...mono,fontSize:'0.6rem',color:err<3?T.green:err<8?T.amber:T.red}}>ΔE {err.toFixed(1)}</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <button className="tap" onClick={()=>{setMatrix(null);setCalibDone(false);setCalibSamples([]);setCalibStep(0);}}
                        style={{background:'transparent',border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:6,padding:'8px',...mono,fontSize:'0.62rem',textTransform:'uppercase',cursor:'pointer'}}>
                        Kalibratie wissen
                      </button>
                    </div>)
                }
              </div>
            )}
            </div>
          </div>
        )}

        {/* ==== LOG TAB ==== */}
        {tab==='log' && (
          <div style={{maxWidth:700,margin:'0 auto',display:'flex',flexDirection:'column',gap:14}}>
            {/* Active project banner */}
            {activeProject && (()=>{
              const proj = projects.find(p=>p.id===activeProject);
              if(!proj) return null;
              return (
                <div style={{background:dark?'#0f1f0f':'#e8f5e8',border:`1px solid ${T.greenBorder}`,borderRadius:8,padding:'10px 13px',display:'flex',alignItems:'center',gap:10,marginBottom:16}}>
                  <div style={{width:8,height:8,borderRadius:'50%',background:T.green,flexShrink:0}} className="pulse"/>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{...mono,fontSize:'0.6rem',color:T.green,letterSpacing:'0.1em',textTransform:'uppercase',marginBottom:1}}>Actief project</div>
                    <div style={{...mono,fontSize:'0.78rem',color:T.text,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{proj.name}</div>
                    <div style={{...mono,fontSize:'0.58rem',color:T.textMuted}}>{(proj.photos||[]).length} foto{(proj.photos||[]).length!==1?'s':''} · {projectScanCount(proj)} scan{projectScanCount(proj)!==1?'s':''}</div>
                  </div>
                  <button className="tap" onClick={()=>setActiveProject(null)}
                    style={{background:'transparent',border:`1px solid ${T.greenBorder}`,color:T.green,borderRadius:6,padding:'5px 9px',...mono,fontSize:'0.6rem',cursor:'pointer',whiteSpace:'nowrap'}}>
                    Stop
                  </button>
                </div>
              );
            })()}

            {/* Project list */}
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
              <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.2rem',color:T.accent,letterSpacing:'0.06em'}}>Projecten</span>
              <button className="tap" onClick={()=>isPro?setShowNewProj(true):setShowUpgrade(true)}
                style={{background:isPro?T.btnPrimary:T.surface,color:isPro?T.btnPrimaryText:T.textMuted,border:`1px solid ${isPro?'transparent':T.border}`,borderRadius:6,padding:'7px 12px',...mono,fontSize:'0.68rem',cursor:'pointer',display:'flex',alignItems:'center',gap:5}}>
                {!isPro && <IconLock size={11} color={T.textFaint}/>}
                <span style={{fontSize:'1rem',lineHeight:1}}>{isPro?'+':''}</span>{isPro?' Nieuw project':' Nieuw project'}
              </button>
            </div>

            {projects.length===0 ? (
              <div style={{textAlign:'center',padding:'30px 20px',color:T.textMuted,...mono,fontSize:'0.72rem',lineHeight:1.7,background:T.surface,borderRadius:8,border:`1px solid ${T.border}`}}>
                Nog geen projecten.<br/>Maak een project aan om scans te groeperen.
              </div>
            ) : (
              <div style={{display:'flex',flexDirection:'column',gap:8}}>
                {projects.map(proj=>{
                  const isActive    = activeProject===proj.id;
                  const isCollapsed = collapsedProj[proj.id]!==false;
                  const toggle      = ()=>setCollapsedProj(p=>({...p,[proj.id]:!isCollapsed}));
                  return (
                    <div key={proj.id} style={{background:isActive?(dark?'#0f1f0f':'#e8f5e8'):T.cardBg,border:`1.5px solid ${isActive?T.green:T.cardBorder}`,borderRadius:10,overflow:'hidden',transition:'border-color 0.15s'}}>

                      {/* Header — always visible */}
                      <div style={{padding:'10px 12px',display:'flex',alignItems:'center',gap:7}}>
                        <button className="tap" onClick={toggle}
                          style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:'2px 3px',flexShrink:0,lineHeight:0}}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                            style={{transition:'transform 0.2s',transform:isCollapsed?'rotate(-90deg)':'rotate(0deg)',display:'block'}}>
                            <polyline points="6 9 12 15 18 9"/>
                          </svg>
                        </button>
                        <div style={{flex:1,minWidth:0,cursor:'pointer'}} onClick={toggle}>
                          <div style={{display:'flex',alignItems:'center',gap:6}}>
                            <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.05rem',color:isActive?T.green:T.accent,letterSpacing:'0.04em',lineHeight:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',minWidth:0}}>{proj.name}</div>
                            <button className="tap" onClick={(e)=>{e.stopPropagation();setRenamingProj(proj);setRenameName(proj.name);}}
                              title="Hernoem"
                              style={{background:'transparent',border:'none',color:T.textMuted,cursor:'pointer',padding:'2px',display:'flex',alignItems:'center',flexShrink:0,lineHeight:0,opacity:0.6}}>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                            </button>
                          </div>
                          <div style={{...mono,fontSize:'0.58rem',color:T.textMuted,marginTop:1}}>{proj.date} · {(proj.photos||[]).length} foto{(proj.photos||[]).length!==1?'s':''} · {projectScanCount(proj)} scan{projectScanCount(proj)!==1?'s':''}{isActive?' · actief':''}</div>
                        </div>
                        <div style={{display:'flex',gap:5,flexShrink:0}}>
                          {!isActive
                            ? <button className="tap" onClick={()=>{setActiveProject(proj.id);setActivePhotoId(null);}}
                                style={{background:T.surface,border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:6,padding:'4px 8px',...mono,fontSize:'0.57rem',cursor:'pointer'}}>
                                Activeer
                              </button>
                            : <button className="tap" onClick={()=>{setActiveProject(null);setActivePhotoId(null);}}
                                style={{background:dark?'#0f2a0f':'#e0f0e0',border:`1px solid ${T.green}44`,color:T.green,borderRadius:6,padding:'4px 8px',...mono,fontSize:'0.57rem',cursor:'pointer'}}>
                                Stop
                              </button>
                          }
                          <button className="tap" onClick={()=>{
                            if(!window.confirm('Project "'+proj.name+'" verwijderen?')) return;
                            setProjects(prev=>{
                              const next=prev.filter(p=>p.id!==proj.id);
                              saveProjects(next, user?.id);
                              return next;
                            });
                            if(activeProject===proj.id){setActiveProject(null);setActivePhotoId(null);}
                          }}
                            style={{background:'transparent',border:`1px solid ${T.border}`,color:T.textMuted,borderRadius:6,padding:'4px 6px',...mono,fontSize:'0.65rem',cursor:'pointer'}}>
                            ✕
                          </button>
                        </div>
                      </div>

                      {/* Expanded content — v0.36: per foto gegroepeerd */}
                      {!isCollapsed && (<>
                        {(proj.photos||[]).length === 0
                          ? <div style={{padding:'10px 14px 14px',...mono,fontSize:'0.68rem',color:T.textMuted,borderTop:`1px solid ${T.divider}`}}>
                              Nog geen foto's. Activeer dit project en voeg foto's toe.
                            </div>
                          : <div style={{borderTop:`1px solid ${T.divider}`,display:'flex',flexDirection:'column'}}>
                              {(proj.photos||[]).map((ph,phIdx) => {
                                const scans = ph.scans || [];
                                const isLastPhoto = phIdx === (proj.photos.length-1);
                                return (
                                  <div key={ph.id} style={{borderBottom:!isLastPhoto?`1px solid ${T.divider}`:'none'}}>
                                    {/* Foto header */}
                                    <div style={{padding:'8px 12px',display:'flex',alignItems:'center',gap:9,background:dark?'#0f0f0f':'#fafaf6'}}>
                                      <div style={{width:32,height:32,borderRadius:5,overflow:'hidden',background:T.surface,border:`1px solid ${T.border}`,flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        {ph.imgData
                                          ? <img src={ph.imgData} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                                          : <span style={{...mono,fontSize:'0.55rem',color:T.textFaint}}>—</span>
                                        }
                                      </div>
                                      <div style={{flex:1,minWidth:0}}>
                                        <div style={{...mono,fontSize:'0.62rem',color:T.text,letterSpacing:'0.04em'}}>Foto {phIdx+1}</div>
                                        <div style={{...mono,fontSize:'0.55rem',color:T.textMuted,marginTop:1}}>
                                          {scans.length} scan{scans.length!==1?'s':''}
                                        </div>
                                      </div>
                                    </div>
                                    {/* Scans van deze foto */}
                                    {scans.length === 0
                                      ? <div style={{padding:'8px 14px 10px 53px',...mono,fontSize:'0.6rem',color:T.textFaint,fontStyle:'italic'}}>geen scans op deze foto</div>
                                      : scans.map((s,si)=>{
                                          const swipeKey = proj.id+'_'+ph.id+'_'+si;
                                          const offset = swipeOffset[swipeKey] || 0;
                                          const deleteScan = () => {
                                            setProjects(prev=>{
                                              const next = prev.map(p => p.id===proj.id
                                                ? {...p, photos:p.photos.map(phh => phh.id===ph.id
                                                    ? {...phh, scans: phh.scans.filter((_,i)=>i!==si)}
                                                    : phh)}
                                                : p);
                                              saveProjects(next, user?.id);
                                              return next;
                                            });
                                            setSwipeOffset(prev=>{const n={...prev};delete n[swipeKey];return n;});
                                          };
                                          return (
                                            <div key={si} style={{position:'relative',overflow:'hidden'}}>
                                              {/* Red delete background */}
                                              <div style={{position:'absolute',inset:0,background:'#e53935',display:'flex',alignItems:'center',justifyContent:'flex-end',paddingRight:16}}>
                                                <button onClick={deleteScan}
                                                  style={{background:'transparent',border:'none',cursor:'pointer',padding:'4px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                                                  </svg>
                                                </button>
                                              </div>
                                              {/* Swipeable row */}
                                              <div
                                                style={{padding:'7px 14px 7px 53px',display:'flex',alignItems:'center',gap:9,
                                                  background:T.cardBg,
                                                  transform:`translateX(${Math.min(0,Math.max(-72,offset))}px)`,
                                                  transition: swipeTouchStart.current[swipeKey] ? 'none' : 'transform 0.2s ease',
                                                  willChange:'transform',
                                                  position:'relative',
                                                  borderTop:`1px solid ${T.divider}`,
                                                }}
                                                onTouchStart={e=>{
                                                  setSwipeOffset(prev=>{
                                                    const n={};
                                                    Object.keys(prev).forEach(k=>{ if(k!==swipeKey) n[k]=0; else n[k]=prev[k]; });
                                                    return n;
                                                  });
                                                  swipeTouchStart.current[swipeKey] = {
                                                    x: e.touches[0].clientX,
                                                    y: e.touches[0].clientY,
                                                    initOffset: swipeOffset[swipeKey]||0,
                                                  };
                                                  swipeScrolled.current[swipeKey] = false;
                                                }}
                                                onTouchMove={e=>{
                                                  const start = swipeTouchStart.current[swipeKey];
                                                  if(!start) return;
                                                  const dx = e.touches[0].clientX - start.x;
                                                  const dy = e.touches[0].clientY - start.y;
                                                  if(!swipeScrolled.current[swipeKey] && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
                                                    swipeScrolled.current[swipeKey] = true;
                                                  }
                                                  if(swipeScrolled.current[swipeKey]) return;
                                                  e.preventDefault();
                                                  const newOffset = Math.min(0, Math.max(-72, start.initOffset + dx));
                                                  setSwipeOffset(prev=>({...prev,[swipeKey]:newOffset}));
                                                }}
                                                onTouchEnd={e=>{
                                                  const start = swipeTouchStart.current[swipeKey];
                                                  if(!start || swipeScrolled.current[swipeKey]) {
                                                    delete swipeTouchStart.current[swipeKey];
                                                    return;
                                                  }
                                                  delete swipeTouchStart.current[swipeKey];
                                                  const current = swipeOffset[swipeKey]||0;
                                                  if(current < -40) {
                                                    setSwipeOffset(prev=>({...prev,[swipeKey]:-64}));
                                                  } else {
                                                    setSwipeOffset(prev=>({...prev,[swipeKey]:0}));
                                                  }
                                                }}
                                              >
                                                <div style={{display:'flex',gap:3,flexShrink:0}}>
                                                  <div style={{width:22,height:22,borderRadius:3,background:s.hex,border:`1px solid ${T.swatchBorder}`}}/>
                                                  <div style={{width:22,height:22,borderRadius:3,background:s.ral.hex,border:`1px solid ${T.swatchBorder}`}}/>
                                                </div>
                                                <div style={{flex:1,minWidth:0}}>
                                                  <div style={{...mono,fontSize:'0.66rem',color:T.text}}>{s.ral.code} <span style={{color:T.accent}}>{s.ral.name}</span></div>
                                                  {s.note&&<div style={{...mono,fontSize:'0.56rem',color:T.textMuted,fontStyle:'italic',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>"{s.note}"</div>}
                                                </div>
                                                {s.calibrated && <span style={{...mono,fontSize:'0.5rem',background:T.greenBg,color:T.green,padding:'2px 5px',borderRadius:8,flexShrink:0,whiteSpace:'nowrap'}}>✓ gekalibreerd</span>}
                                              </div>
                                            </div>
                                          );
                                        })
                                    }
                                  </div>
                                );
                              })}
                            </div>
                        }
                      </>)}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}



        <div style={{...mono,fontSize:'0.55rem',color:T.textFaint,textAlign:'right',padding:'24px 4px 0',letterSpacing:'0.08em'}}>{VERSION}</div>
      </div>
    </div>
  );
}